webpackJsonp([17],{

/***/ 2344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PropTypes = __webpack_require__(85);

var _withRouter = __webpack_require__(159);

var _withRouter2 = _interopRequireDefault(_withRouter);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _JPWidgetSchemas = __webpack_require__(2954);

var _PreviousSearchesStore = __webpack_require__(621);

var _PreviousSearchesStore2 = _interopRequireDefault(_PreviousSearchesStore);

var _SmartCarnetRecordSearch = __webpack_require__(436);

var _SmartCarnetRecordSearch2 = _interopRequireDefault(_SmartCarnetRecordSearch);

var _DaySaveSearch = __webpack_require__(420);

var _DaySaveSearch2 = _interopRequireDefault(_DaySaveSearch);

var _RoversRangersSearch = __webpack_require__(595);

var _RoversRangersSearch2 = _interopRequireDefault(_RoversRangersSearch);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Map = __webpack_require__(2407);

var _Map2 = _interopRequireDefault(_Map);

var _ResponsiveRender = __webpack_require__(982);

var _ResponsiveRender2 = _interopRequireDefault(_ResponsiveRender);

var _LeftColumn = __webpack_require__(2699);

var _LeftColumn2 = _interopRequireDefault(_LeftColumn);

var _SecretVersion = __webpack_require__(3448);

var _SecretVersion2 = _interopRequireDefault(_SecretVersion);

var _JPWidget = __webpack_require__(2704);

var _JPWidget2 = _interopRequireDefault(_JPWidget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores() {
    var previousSmartCarnetSearch = _PreviousSearchesStore2.default.get('smartCarnet');
    var previousDaySaveSearch = _PreviousSearchesStore2.default.get('daySave').refreshDates();
    var previousRoversSearch = _PreviousSearchesStore2.default.get('roversRangers').refreshDates();

    return {
        previousSmartCarnetSearch: previousSmartCarnetSearch,
        previousDaySaveSearch: previousDaySaveSearch,
        previousRoversSearch: previousRoversSearch
    };
}

var OtherSearch = (_dec = (0, _connectToStores2.default)([_PreviousSearchesStore2.default], _getStateFromStores), _dec(_class = (0, _withRouter2.default)(_class = (_temp2 = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(OtherSearch, _React$PureComponent);

    function OtherSearch() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, OtherSearch);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.performSearch = function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(url) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.props.router.push(url);

                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    OtherSearch.prototype.componentDidMount = function componentDidMount() {
        if (!_FeatureFlagStore2.default.get('enableMap')) {
            this.props.router.push(_urls2.default.location(_AppConstants.PointStages.SEARCH));
        }
    };

    OtherSearch.prototype.render = function render() {
        var _this3 = this;

        return _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
                _LeftColumn2.default,
                { title: (0, _I18n2.default)('pageTitles.other-search') },
                _react2.default.createElement(
                    "section",
                    { className: "booking__section other-ticket-options" },
                    _react2.default.createElement(_JPWidget2.default, {
                        params: {
                            brand: _config2.default.get('tocCode'),
                            apiUrl: "https://" + _config2.default.get('apiHost'),
                            stylesheetUrl: _config2.default.get('jpWidgetStylesheetUrl'),
                            vertical: true,
                            activeTab: "OTHER",
                            hideNavigation: true,
                            disableBackground: true,
                            hidePromotionalText: true,
                            enableDaySave: _FeatureFlagStore2.default.get('enableDaySave') && !_FeatureFlagStore2.default.get('enableHiddenDaySave'),
                            enableRoversRangers: _FeatureFlagStore2.default.get('enableRoversRangers'),
                            enableSmartCarnet: _FeatureFlagStore2.default.get('enableSmartCarnet'),
                            disabledTabs: "",
                            enableKentRover: _FeatureFlagStore2.default.get('enableKentRover'),
                            searchCallBack: function searchCallBack(url, data) {
                                return _this3.performSearch(url, data);
                            },
                            defaultValues: {
                                ticketTypes: (0, _extends3.default)({}, (0, _JPWidgetSchemas.smartCarnetSchema)(this.props.previousSmartCarnetSearch), (0, _JPWidgetSchemas.daySaveSchema)(this.props.previousDaySaveSearch), (0, _JPWidgetSchemas.roversRangersSchema)(this.props.previousRoversSearch))
                            }
                        }
                    }),
                    _react2.default.createElement(_SecretVersion2.default, null)
                )
            ),
            _react2.default.createElement(
                _ResponsiveRender2.default,
                { minWidth: _AppConstants.BreakPoints.TABLET_PORTRAIT_WIDTH },
                _react2.default.createElement(_Map2.default, { className: 'map right-col' })
            )
        );
    };

    return OtherSearch;
}(_react2.default.PureComponent), _class2.propTypes = {
    router: _PropTypes.routerShape,
    previousSmartCarnetSearch: _propTypes2.default.instanceOf(_SmartCarnetRecordSearch2.default),
    previousDaySaveSearch: _propTypes2.default.instanceOf(_DaySaveSearch2.default),
    previousRoversSearch: _propTypes2.default.instanceOf(_RoversRangersSearch2.default)
}, _temp2)) || _class) || _class);
exports.default = OtherSearch;

/***/ }),

/***/ 2397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getOwnPropertyDescriptor = __webpack_require__(233);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _head2 = __webpack_require__(993);

var _head3 = _interopRequireDefault(_head2);

var _takeRight3 = __webpack_require__(2417);

var _takeRight4 = _interopRequireDefault(_takeRight3);

var _invokeMap2 = __webpack_require__(1003);

var _invokeMap3 = _interopRequireDefault(_invokeMap2);

var _isUndefined2 = __webpack_require__(278);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _desc, _value, _class; /* global google */

var _GoogleMapStyles = __webpack_require__(2418);

var _GoogleMapStyles2 = _interopRequireDefault(_GoogleMapStyles);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

var defaultCenter = { lat: 53, lng: -1.8 };
var defaultZoom = 7;
var zoomOutLimit = 4;

var _pathToLatLngs = function _pathToLatLngs(path) {
    var result = path.map(function (coords) {
        var latitude = coords.latitude,
            longitude = coords.longitude;

        return new google.maps.LatLng(latitude, longitude);
    });

    return (0, _isUndefined3.default)(result.toJS) ? result : result.toJS();
};

/**
 * Decorator that logs any exceptions with console.error instead of throwing them
 * We don't want google maps errors to stop the user from progressing
 */
function errorToLog(target, name, descriptor) {
    var original = descriptor.value;
    descriptor.value = function () {
        try {
            return original.apply(this, arguments);
        } catch (e) {
            console.error("Google Maps Error", e);
            return null;
        }
    };
    return descriptor;
}

var GoogleMapsHelper = (_class = function () {
    function GoogleMapsHelper(domNode, next) {
        var _this = this;

        (0, _classCallCheck3.default)(this, GoogleMapsHelper);

        this.callback = function () {
            window.callback = void 0;
            delete window.callback;
            _this.next(_this.createMap());
        };

        this.map = null;
        this.loaded = false;
        this.domNode = domNode;
        this.next = next;
        this.objects = [];
        this.bounds = null;
        this.loadGoogleMaps();
    }

    GoogleMapsHelper.prototype.addEventListener = function addEventListener(event, callback) {
        if (this.map) {
            window.google.maps.event.addListener(this.map, event, callback);
        }
    };

    GoogleMapsHelper.prototype.refresh = function refresh() {
        this.bounds = new google.maps.LatLngBounds();
        (0, _invokeMap3.default)(this.objects, 'setMap', null);
        this.objects = [];
    };

    GoogleMapsHelper.prototype.resize = function resize() {
        window.google.maps.event.trigger(this.map, 'resize');
    };

    /**
     * Fit bounds zooms in too close to single bounds so zoom out a little
     * by adding extra bounds
     */


    GoogleMapsHelper.prototype.zoomOutSingleBound = function zoomOutSingleBound() {
        var bounds = this.bounds;
        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
        }
        return this.bounds;
    };

    GoogleMapsHelper.prototype.fitBounds = function fitBounds() {
        var bounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.bounds;

        if (!bounds.isEmpty()) {
            this.map.fitBounds(this.zoomOutSingleBound());
        } else {
            this.map.setCenter(defaultCenter);
            this.map.setZoom(defaultZoom);
        }
    };

    GoogleMapsHelper.prototype.loadGoogleMaps = function loadGoogleMaps() {
        if (!window.google) {

            var existingCallback = window.callback;
            window.callback = this.callback;

            //Avoid loading the script if there is already a pending callback
            if (!existingCallback) {
                var script = document.createElement('script');
                script.setAttribute('src', _config2.default.get('googleMapsSrc') + _config2.default.get('googleMapsApiKey'));
                document.head.appendChild(script);
            }
        } else {
            // Due to async nature of loading/rendering
            setTimeout(this.callback.bind(this), 0);
        }
    };

    GoogleMapsHelper.prototype.createMap = function createMap() {
        this.map = new google.maps.Map(this.domNode, {
            zoom: defaultZoom,
            minZoom: zoomOutLimit,
            draggable: true,
            zoomControl: true,
            scrollwheel: true,
            disableDefaultUI: false,
            disableDoubleClickZoom: false,
            center: defaultCenter,
            styles: _GoogleMapStyles2.default,
            mapTypeControl: false,
            streetViewControl: false
        });

        this.loaded = true;
        return this.map;
    };

    GoogleMapsHelper.prototype.dashedLine = function dashedLine(path) {
        var _this2 = this;

        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.get('googleMapPrimaryColour');

        var lineSymbol = {
            path: 'M 0,-1 0,1',
            strokeColor: color,
            strokeOpacity: 1,
            scale: 4
        };

        var dashed = new google.maps.Polyline({
            path: _pathToLatLngs(path),
            strokeOpacity: 0,
            icons: [{ icon: lineSymbol, offset: '0', repeat: '25px' }],
            map: this.map
        });

        path.forEach(function (coords) {
            var marker = document.createElement('div');
            marker.style.background = color;
            marker.className = 'map__calling-point';
            _this2.newLabel(marker, coords);
        });

        this.objects.push(dashed);
    };

    GoogleMapsHelper.prototype.solidLine = function solidLine(path) {
        var _this3 = this;

        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.get('googleMapPrimaryColour');

        path = path.map(function (coords) {
            if (!coords.latitude || !coords.longitude) {
                return null;
            }

            var latitude = coords.latitude,
                longitude = coords.longitude;

            var latLng = new google.maps.LatLng(latitude, longitude);
            _this3.bounds.extend(latLng);
            return latLng;
        }).toJS();

        var solid = new google.maps.Polyline({
            map: this.map,
            path: path,
            strokeColor: color,
            strokeOpacity: 1,
            strokeWeight: 4,
            clickable: false,
            editable: false,
            visible: true
        });

        this.objects.push(solid);
    };

    GoogleMapsHelper.prototype.points = function points(path) {
        var _this4 = this;

        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.get('googleMapPrimaryColour');

        path.forEach(function (coords) {
            var marker = document.createElement('div');
            marker.style.background = color;
            marker.className = 'map__calling-point';
            _this4.newLabel(marker, coords);
        });
    };

    GoogleMapsHelper.prototype.newLabel = function newLabel(element, coords) {
        if (!coords.latitude || !coords.longitude) {
            return null;
        }

        var latLng = new google.maps.LatLng(coords.latitude, coords.longitude);
        var map = this.map;
        var Overlay = function Overlay() {
            this.setMap(map);
        };
        Overlay.prototype = new google.maps.OverlayView();
        Overlay.prototype.onAdd = function () {
            this.getPanes().floatPane.appendChild(element);
        };
        Overlay.prototype.draw = function () {
            var projection = this.getProjection();
            var pos = projection.fromLatLngToDivPixel(latLng);
            element.style.position = 'absolute';
            element.style.left = pos.x + 'px';
            element.style.top = pos.y + 'px';
        };
        Overlay.prototype.onRemove = function () {
            if (element.parentNode) {
                element.parentNode.removeChild(element);
            }
            element = null;
        };

        var label = new Overlay();

        this.objects.push(label);
        this.bounds.extend(latLng);

        return label;
    };

    GoogleMapsHelper.prototype.getDistance = function getDistance(x, y) {
        return google.maps.geometry.spherical.computeDistanceBetween(x, y);
    };

    GoogleMapsHelper.prototype.getRoutePairs = function getRoutePairs(route) {
        return route.map(function (x, i) {
            return [x, route[i + 1]];
        }).splice(0, route.length - 2); // Remove last one
    };

    GoogleMapsHelper.prototype.getRouteDistance = function getRouteDistance(route) {
        return google.maps.geometry.spherical.computeLength(route);
    };

    GoogleMapsHelper.prototype.getRouteMiddle = function getRouteMiddle(route) {
        var _this5 = this;

        var latLngs = _pathToLatLngs(route),
            roughMiddle = this.getRouteDistance(latLngs) / 2,
            pairs = this.getRoutePairs(latLngs),
            distances = pairs.map(function (xCoord) {
            return _this5.getDistance.apply(_this5, xCoord);
        }),
            runningTotal = 0;

        for (var i = 0; i < distances.length; i++) {
            var curDistance = runningTotal + distances[i];

            if (curDistance >= roughMiddle) {
                var _pairs$i = pairs[i],
                    x = _pairs$i[0],
                    y = _pairs$i[1],
                    p = (roughMiddle - runningTotal) / (curDistance - runningTotal);


                return google.maps.geometry.spherical.interpolate(x, y, p);
            }

            runningTotal = curDistance;
        }

        var _takeRight2 = (0, _takeRight4.default)(latLngs, 2),
            posX = _takeRight2[0],
            posY = _takeRight2[1];

        if (!posX || !posY) {
            return (0, _head3.default)(latLngs);
        }
        return google.maps.geometry.spherical.interpolate(posX, posY, 0.5);
    };

    GoogleMapsHelper.prototype.getZoomLevel = function getZoomLevel() {
        return this.map.getZoom();
    };

    GoogleMapsHelper.prototype.setZoomLevel = function setZoomLevel(level) {
        this.map.setZoom(level);
    };

    GoogleMapsHelper.prototype.setCenter = function setCenter(pos) {
        this.map.setCenter(pos);
    };

    GoogleMapsHelper.prototype.addMarker = function addMarker(_ref) {
        var animation = _ref.animation,
            options = (0, _objectWithoutProperties3.default)(_ref, ['animation']);

        if (animation) {
            animation = google.maps.Animation[animation];
        }
        return new google.maps.Marker((0, _assign2.default)({}, options, { map: this.map, animation: animation }));
    };

    return GoogleMapsHelper;
}(), (_applyDecoratedDescriptor(_class.prototype, 'zoomOutSingleBound', [errorToLog], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'zoomOutSingleBound'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fitBounds', [errorToLog], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'fitBounds'), _class.prototype)), _class);
exports.default = GoogleMapsHelper;

/***/ }),

/***/ 2407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _shallowequal = __webpack_require__(1005);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _GoogleMaps = __webpack_require__(2397);

var _GoogleMaps2 = _interopRequireDefault(_GoogleMaps);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapComponent = (_temp2 = _class = function (_React$Component) {
    (0, _inherits3.default)(MapComponent, _React$Component);

    function MapComponent() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, MapComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            loaded: false,
            expandMap: false
        }, _this._onMapLoaded = function () {
            _this.setState({ loaded: true });
        }, _this._toggleMapExpand = function () {
            _this.setState({ expandMap: !_this.state.expandMap }, function () {
                setTimeout(function () {
                    _this.mapsHelper.resize();
                    _this.mapsHelper.fitBounds();
                }, 1);
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    /**
     * Pure render mixin shallow compares, so doesn't know if children change,
     * so we check if the props on the children have changed and if their keys match,
     * so to reduce requests, all children to this component need keys.
     */
    MapComponent.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var nextChildren = [];
        var currentChildren = [];
        _react2.default.Children.forEach(nextProps.children, function (child) {
            return nextChildren.push(child);
        });
        _react2.default.Children.forEach(this.props.children, function (child) {
            return currentChildren.push(child);
        });

        var childrenChanged = nextChildren.reduce(function (out, child) {
            var matched = currentChildren.filter(function (existing) {
                return child.key === existing.key;
            });
            if (!matched || !matched.length) {
                return true;
            }
            return out || !(0, _shallowequal2.default)(matched[0].props, child.props);
        }, false);

        return !(0, _shallowequal2.default)(this.state, nextState) || childrenChanged;
    };

    MapComponent.prototype.componentDidMount = function componentDidMount() {
        this.mapsHelper = new _GoogleMaps2.default(this.refs.map, this._onMapLoaded);
        this.props.onReady(this.mapsHelper);
    };

    MapComponent.prototype.componentDidUpdate = function componentDidUpdate() {
        if (this.state.loaded && !this.props.stationFinderActive) {
            this.mapsHelper.fitBounds();
        }
    };

    MapComponent.prototype._renderChildren = function _renderChildren() {
        var _this2 = this;

        if (!this.state.loaded) {
            return null;
        }

        return _react2.default.Children.map(this.props.children, function (child, index) {
            return _react2.default.cloneElement(child, {
                key: index,
                mapsHelper: _this2.mapsHelper
            });
        });
    };

    MapComponent.prototype.render = function render() {
        var style = { width: '100%', height: '100%' };
        var classNames = (0, _classnames2.default)(this.props.className, { 'right-col--expand-map': this.state.expandMap });
        var allowMapExpand = this.props.allowMapExpand;

        if (this.state.loaded) {
            this.mapsHelper.refresh();
        }

        var buttonClass = (0, _classnames2.default)('map-expander box box--rounded box--padded', {
            'map-expander--active': this.state.expandMap
        });

        return _react2.default.createElement(
            'div',
            { className: classNames, style: this.props.style },
            this._renderChildren(),
            _react2.default.createElement('div', { style: style, ref: 'map' }),
            allowMapExpand && _react2.default.createElement(
                'button',
                {
                    className: buttonClass,
                    type: 'button',
                    'aria-label': (0, _I18n.translate)('ariaLabel.toggleMap'),
                    onClick: this._toggleMapExpand
                },
                _react2.default.createElement(_Icon2.default, { icon: 'arrowback', className: 'otrl-rotate-45' }),
                _react2.default.createElement(_Icon2.default, { icon: 'arrowback', className: 'otrl-rotate-225' })
            )
        );
    };

    return MapComponent;
}(_react2.default.Component), _class.propTypes = {
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    children: _propTypes2.default.any,
    allowMapExpand: _propTypes2.default.bool,
    onReady: _propTypes2.default.func,
    stationFinderActive: _propTypes2.default.bool
}, _class.defaultProps = {
    allowMapExpand: true,
    className: '',
    style: {},
    onReady: _noop3.default,
    stationFinderActive: false
}, _temp2);
exports.default = MapComponent;

/***/ }),

/***/ 2417:
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(432),
    toInteger = __webpack_require__(200);

/**
 * Creates a slice of `array` with `n` elements taken from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.takeRight([1, 2, 3]);
 * // => [3]
 *
 * _.takeRight([1, 2, 3], 2);
 * // => [2, 3]
 *
 * _.takeRight([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.takeRight([1, 2, 3], 0);
 * // => []
 */
function takeRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, n < 0 ? 0 : n, length);
}

module.exports = takeRight;


/***/ }),

/***/ 2418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * https://snazzymaps.com/editor
 */
exports.default = [{
    "featureType": "administrative.country",
    "elementType": "all",
    "stylers": [{
        "visibility": "on"
    }]
}, {
    "featureType": "administrative.country",
    "elementType": "labels.text",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "administrative.province",
    "elementType": "labels.text",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "administrative.locality",
    "elementType": "labels.text.fill",
    "stylers": [{
        "lightness": "-100"
    }]
}, {
    "featureType": "administrative.neighborhood",
    "elementType": "labels.text.fill",
    "stylers": [{
        "visibility": "on"
    }, {
        "lightness": "-70"
    }]
}, {
    "featureType": "landscape.natural",
    "elementType": "labels.text.fill",
    "stylers": [{
        "lightness": "-60"
    }]
}, {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [{
        "lightness": "25"
    }]
}, {
    "featureType": "poi",
    "elementType": "labels",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{
        "visibility": "simplified"
    }]
}, {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [{
        "visibility": "simplified"
    }]
}, {
    "featureType": "road",
    "elementType": "labels.text",
    "stylers": [{
        "color": "#8c8c8f"
    }]
}, {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [{
        "visibility": "simplified"
    }, {
        "color": "#ffffff"
    }]
}, {
    "featureType": "road.highway.controlled_access",
    "elementType": "geometry",
    "stylers": [{
        "visibility": "on"
    }]
}, {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [{
        "visibility": "on"
    }]
}, {
    "featureType": "transit.station",
    "elementType": "all",
    "stylers": [{
        "visibility": "on"
    }]
}];

/***/ }),

/***/ 2431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _Payment = __webpack_require__(423);

var _Smartcard = __webpack_require__(336);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PaymentError(_ref) {
    var error = _ref.error,
        message = _ref.message,
        onRetry = _ref.onRetry,
        retryLabel = _ref.retryLabel;

    if (!message) {
        var errorMessage = void 0;
        var messageKey = void 0;
        if (error instanceof _Smartcard.ACTError) {
            messageKey = 'confirmation.externalError';
            errorMessage = (0, _I18n.translate)('confirmation.externalErrorMessage');
        } else {
            messageKey = (0, _result3.default)(_AppConstants.PaymentAuthCodes, errorMessage) ? 'payment.error.' + errorMessage : 'payment.error.UNKNOWN_ERROR';
            errorMessage = (0, _get3.default)(error, 'message');
        }
        message = (0, _I18n.translate)(messageKey, { message: errorMessage });
    }

    return _react2.default.createElement(
        'div',
        { className: 'confirmation text-center js-payment-result', 'data-error': message || error },
        _react2.default.createElement(_Icon2.default, { icon: 'clear margin-bottom--sm otrl-xl' }),
        _react2.default.createElement(
            'p',
            { className: 'alert-danger text-weight--normal' },
            (0, _I18n.translate)('confirmation.decline')
        ),
        _react2.default.createElement(
            'p',
            { className: 'text-sm margin-bottom' },
            message
        ),
        onRetry && _react2.default.createElement(
            _Button2.default,
            { bsStyle: 'default', onClick: onRetry },
            (0, _I18n.translate)(retryLabel),
            _react2.default.createElement(_Icon2.default, { className: 'pull-left otrl-rotate-180', icon: 'chevron' })
        )
    );
}

PaymentError.propTypes = {
    error: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Payment.PaymentUnauthorizedError), _propTypes2.default.instanceOf(_Smartcard.ACTError)]),
    message: _propTypes2.default.string,
    onRetry: _propTypes2.default.func,
    retryLabel: _propTypes2.default.string
};

PaymentError.defaultProps = {
    onRetry: null,
    retryLabel: 'confirmation.backToPayment'
};

exports.default = PaymentError;

/***/ }),

/***/ 2442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _Link = __webpack_require__(275);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SmartcardReplacementWarning() {
    return _react2.default.createElement(
        'div',
        { className: 'margin-top padding-bottom' },
        _react2.default.createElement(
            'div',
            { className: 'clearfix margin-top' },
            _react2.default.createElement(
                'h2',
                { className: 'text-lg text-weight--normal no-margin padding-bottom--sm alert-warning' },
                (0, _I18n.translate)('account.heading.smartcard.replacement.warning')
            ),
            _react2.default.createElement(
                'div',
                { className: 'box box--padded box--rounded box--warning' },
                _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(
                        _Col2.default,
                        { sm: 12, md: 12, lg: 10 },
                        _react2.default.createElement(
                            'p',
                            { className: 'alert-warning' },
                            (0, _I18n.translate)('account.smartcard.text.replacement.warning')
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: 'no-margin' },
                            _react2.default.createElement(
                                _Link2.default,
                                { to: _AppConstants.AccountPages.SMARTCARD_REPLACEMENT },
                                (0, _I18n.translate)('account.smartcard.text.replacement.linkText')
                            )
                        )
                    )
                )
            )
        )
    );
}

exports.default = SmartcardReplacementWarning;

/***/ }),

/***/ 2444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _CVVIcon = __webpack_require__(2475);

var _CVVIcon2 = _interopRequireDefault(_CVVIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardSecurityCode(props) {
    var hideValueProp = props.hideValue ? { disabled: true, value: '', hideError: true } : null;

    return _react2.default.createElement(
        'div',
        { className: 'card-security-code input-with-addon input-with-addon--right' },
        _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({}, props, {
            type: 'tel',
            id: 'cvv',
            field: 'cv2',
            name: 'cvv',
            label: (0, _I18n.translate)('customerdetails.payment.cvv'),
            placeholder: (0, _I18n.translate)('customerdetails.payment.cvv'),
            labelClassName: 'sr-only',
            autoComplete: 'cc-csc'
        }, hideValueProp)),
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)("cvv-indicator card-security", { 'card-indicator--outside-label': props.outsideLabel }) },
            _react2.default.createElement(_CVVIcon2.default, null)
        )
    );
}

CardSecurityCode.propTypes = (0, _extends3.default)({}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'disabled', 'outsideLabel', 'required', 'visited', 'validation']), {
    hideValue: _propTypes2.default.bool
});

exports.default = CardSecurityCode;

/***/ }),

/***/ 2466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _CardHolderName = __webpack_require__(2467);

var _CardHolderName2 = _interopRequireDefault(_CardHolderName);

var _CardNumber = __webpack_require__(2468);

var _CardNumber2 = _interopRequireDefault(_CardNumber);

var _CardExpiryMonth = __webpack_require__(2473);

var _CardExpiryMonth2 = _interopRequireDefault(_CardExpiryMonth);

var _CardExpiryYear = __webpack_require__(2474);

var _CardExpiryYear2 = _interopRequireDefault(_CardExpiryYear);

var _CardSecurityCode = __webpack_require__(2444);

var _CardSecurityCode2 = _interopRequireDefault(_CardSecurityCode);

var _Error = __webpack_require__(199);

var _Error2 = _interopRequireDefault(_Error);

var _SlashIcon = __webpack_require__(2476);

var _SlashIcon2 = _interopRequireDefault(_SlashIcon);

var _CardForm = __webpack_require__(989);

var _CardForm2 = _interopRequireDefault(_CardForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardDetails(props) {
    var isExpired = props.form.getError('isExpired');
    var Wrapper = props.isSubForm ? 'div' : 'form';
    return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12 },
                _react2.default.createElement(_CardHolderName2.default, (0, _extends3.default)({}, props, { required: true, outsideLabel: true }))
            )
        ),
        _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { md: 6, className: 'card-details__number' },
                _react2.default.createElement(_CardNumber2.default, (0, _extends3.default)({}, props, { required: true, outsideLabel: true, showPlaceholder: true }))
            ),
            _react2.default.createElement(
                _Col2.default,
                { md: 6, className: 'card-details__expiry-and-cvv' },
                _react2.default.createElement(
                    _Row2.default,
                    { className: 'row-padding-md' },
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 12, sm: 8 },
                        _react2.default.createElement(
                            'div',
                            { className: 'card-expiry-with-slash' },
                            _react2.default.createElement(_CardExpiryMonth2.default, (0, _extends3.default)({}, props, { required: true, outsideLabel: true })),
                            _react2.default.createElement(_SlashIcon2.default, { className: 'card-slash' }),
                            _react2.default.createElement(_CardExpiryYear2.default, (0, _extends3.default)({}, props, { required: true, outsideLabel: true }))
                        )
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 6, sm: 4 },
                        _react2.default.createElement(_CardSecurityCode2.default, (0, _extends3.default)({}, props, { required: true, outsideLabel: true }))
                    )
                ),
                isExpired && _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 12, className: 'card-error' },
                        _react2.default.createElement(_Error2.default, { message: isExpired })
                    )
                )
            )
        )
    );
}

CardDetails.propTypes = (0, _extends3.default)({
    isSubForm: _propTypes2.default.bool,
    showLogos: _propTypes2.default.bool,
    form: _propTypes2.default.instanceOf(_CardForm2.default).isRequired
}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'disabled', 'visited', 'validation']));

CardDetails.defaultProps = {
    isSubForm: false
};

exports.default = CardDetails;

/***/ }),

/***/ 2467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardHolderName(props) {

    return _react2.default.createElement(
        'div',
        { className: 'card-holder-name' },
        _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({}, props, {
            type: 'text',
            id: 'cardHolderName',
            name: 'cardholderName',
            field: 'cardHolderName',
            label: (0, _I18n.translate)('customerdetails.payment.cardholder'),
            placeholder: (0, _I18n.translate)('customerdetails.payment.cardholder'),
            labelClassName: 'sr-only',
            autoComplete: 'cc-name'
        }))
    );
}

CardHolderName.propTypes = (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'required', 'disabled', 'visited', 'validation']);

exports.default = CardHolderName;

/***/ }),

/***/ 2468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _slugify = __webpack_require__(626);

var _slugify2 = _interopRequireDefault(_slugify);

var _Card = __webpack_require__(2469);

var _Card2 = _interopRequireDefault(_Card);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _CardForm = __webpack_require__(989);

var _CardForm2 = _interopRequireDefault(_CardForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardNumber(props) {
    var _classnames;

    var cardType = _Card2.default.getType(props.form.cardNumber);
    var cardClassNames = (0, _classnames3.default)('card-indicator', (_classnames = {}, _classnames['card-' + (0, _slugify2.default)(cardType && cardType.toLowerCase())] = !!cardType, _classnames));

    return _react2.default.createElement(
        'div',
        { className: 'card-number input-with-addon input-with-addon--right' },
        _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({}, props, {
            type: 'tel',
            id: 'cardNumber',
            field: 'cardNumber',
            name: 'cc-number',
            label: (0, _I18n.translate)('customerdetails.payment.cardnumber'),
            placeholder: (0, _I18n.translate)('customerdetails.payment.cardnumber.placeholder'),
            showPlaceholder: true,
            labelClassName: 'sr-only',
            autoComplete: 'cc-number'
        })),
        _react2.default.createElement('div', { className: cardClassNames })
    );
}

CardNumber.propTypes = (0, _extends3.default)({
    form: _propTypes2.default.instanceOf(_CardForm2.default).isRequired
}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'disabled', 'required', 'visited', 'validation']));

exports.default = CardNumber;

/***/ }),

/***/ 2469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _findLastKey2 = __webpack_require__(2470);

var _findLastKey3 = _interopRequireDefault(_findLastKey2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    token: null,
    amount: null,
    nickname: null,
    cardHolderName: null,
    startDate: null,
    expiryDate: null,
    email: null,
    phone: null,
    store: false,
    address: new _Address2.default()
};

var Card = function (_Record) {
    (0, _inherits3.default)(Card, _Record);

    function Card() {
        (0, _classCallCheck3.default)(this, Card);
        return (0, _possibleConstructorReturn3.default)(this, _Record.apply(this, arguments));
    }

    // eslint-disable-line new-cap

    Card.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new Card({
            token: (0, _LinkMapper.resolve)(json.token).with(String),
            amount: (0, _LinkMapper.resolve)(json.amount).with(Number),
            nickname: (0, _LinkMapper.resolve)(json.nickname).with(String),
            cardHolderName: (0, _LinkMapper.resolve)(json.cardHolderName).with(String),
            startDate: (0, _LinkMapper.resolve)(json.startDate).with(String),
            expiryDate: (0, _LinkMapper.resolve)(json.expiryDate).with(String),
            email: (0, _LinkMapper.resolve)(json.email).with(String),
            phone: (0, _LinkMapper.resolve)(json.phone).with(String),
            store: (0, _LinkMapper.resolve)(json.stored).with(Boolean),
            address: (0, _LinkMapper.resolve)(json.address).as(_Address2.default)
        });
    };

    Card.getType = function getType() {
        var pan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        return pan ? (0, _findLastKey3.default)(_AppConstants.CardTypes, function (r) {
            return pan.match(r);
        }) : null;
    };

    return Card;
}((0, _immutable.Record)(defaults));

exports.default = Card;

/***/ }),

/***/ 2470:
/***/ (function(module, exports, __webpack_require__) {

var baseFindKey = __webpack_require__(1036),
    baseForOwnRight = __webpack_require__(2471),
    baseIteratee = __webpack_require__(102);

/**
 * This method is like `_.findKey` except that it iterates over elements of
 * a collection in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findLastKey(users, function(o) { return o.age < 40; });
 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastKey(users, { 'age': 36, 'active': true });
 * // => 'barney'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastKey(users, 'active');
 * // => 'pebbles'
 */
function findLastKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwnRight);
}

module.exports = findLastKey;


/***/ }),

/***/ 2471:
/***/ (function(module, exports, __webpack_require__) {

var baseForRight = __webpack_require__(2472),
    keys = __webpack_require__(127);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

module.exports = baseForOwnRight;


/***/ }),

/***/ 2472:
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1027);

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

module.exports = baseForRight;


/***/ }),

/***/ 2473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _range2 = __webpack_require__(339);

var _range3 = _interopRequireDefault(_range2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lpad = __webpack_require__(440);

var _lpad2 = _interopRequireDefault(_lpad);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardExpiryMonth(props) {
    var monthsRange = (0, _range3.default)(1, 13).map(function (month) {
        return (0, _lpad2.default)(month, 2, '0');
    });

    return _react2.default.createElement(
        'div',
        { className: 'card-expiry-month' },
        _react2.default.createElement(
            _ValidatedField2.default,
            (0, _extends3.default)({}, props, {
                type: 'select',
                id: 'expiryMonth',
                name: 'ccmonth',
                field: 'expiryMonth',
                groupClassName: 'select-container select-container--no-margin',
                label: (0, _I18n.translate)('customerdetails.payment.expirymonth'),
                placeholder: (0, _I18n.translate)('customerdetails.payment.expirymonth'),
                labelClassName: 'sr-only',
                autoComplete: 'cc-exp-month' }),
            _react2.default.createElement(
                'option',
                null,
                (0, _I18n.translate)('customerdetails.payment.expirymonth.defaultOption')
            ),
            monthsRange.map(function (month) {
                return _react2.default.createElement(
                    'option',
                    { key: month, value: month },
                    month
                );
            })
        )
    );
}

CardExpiryMonth.propTypes = (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'required', 'disabled', 'visited', 'validation']);

exports.default = CardExpiryMonth;

/***/ }),

/***/ 2474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _range2 = __webpack_require__(339);

var _range3 = _interopRequireDefault(_range2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardExpiryYear(props) {
    var currentYear = (0, _TrainTime2.default)().year();
    var yearsRange = (0, _range3.default)(currentYear, currentYear + 11);

    return _react2.default.createElement(
        'div',
        { className: 'card-expiry-year' },
        _react2.default.createElement(
            _ValidatedField2.default,
            (0, _extends3.default)({}, props, {
                type: 'select',
                id: 'expiryYear',
                name: 'year',
                field: 'expiryYear',
                groupClassName: 'select-container select-container--no-margin',
                label: (0, _I18n.translate)('customerdetails.payment.expiryyear'),
                placeholder: (0, _I18n.translate)('customerdetails.payment.expiryyear'),
                labelClassName: 'sr-only',
                autoComplete: 'cc-exp-year' }),
            _react2.default.createElement(
                'option',
                null,
                (0, _I18n.translate)('customerdetails.payment.expiryyear.defaultOption')
            ),
            yearsRange.map(function (year) {
                return _react2.default.createElement(
                    'option',
                    { key: year, value: year },
                    year
                );
            })
        )
    );
}

CardExpiryYear.propTypes = (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'required', 'disabled', 'visited', 'validation']);

exports.default = CardExpiryYear;

/***/ }),

/***/ 2475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CVVIcon = function CVVIcon() {
    return _react2.default.createElement(
        "svg",
        { xmlns: "http://www.w3.org/2000/svg", height: "25", width: "38", viewBox: "0 0 38.28 23.868" },
        _react2.default.createElement("rect", { ry: "3.536", rx: "3.536", height: "25", width: "38", fill: "#dfdedc" }),
        _react2.default.createElement("rect", { width: "36.28", height: "23.868", x: ".86", y: ".566", rx: "3.536", ry: "3.536", fill: "#cececd" }),
        _react2.default.createElement("rect", { ry: "0", rx: "0", y: "3.995", x: ".86", height: "4.999", width: "36.28", fill: "#434244" }),
        _react2.default.createElement("rect", { width: "22.449", height: "5.031", x: "3.157", y: "12.682", rx: "0", ry: "0", fill: "#fff" }),
        _react2.default.createElement("rect", { ry: "0", rx: "0", y: "14.448", x: "5.501", height: "1.5", width: "17.762", fill: "#434244" }),
        _react2.default.createElement("rect", { ry: "0", rx: "0", y: "12.682", x: "28.907", height: "5.031", width: "4.887", fill: "#fff" }),
        _react2.default.createElement("rect", { width: "3.23", height: "1.5", x: "29.735", y: "14.448", rx: "0", ry: "0", fill: "#434244" }),
        _react2.default.createElement("path", {
            d: "M31.35 9.531c-3.077 0-5.573 2.551-5.573 5.666s2.496 5.666 5.573 5.666c3.076 0 5.574-2.55 5.574-5.666 0-3.115-2.498-5.666-5.574-5.666zm0 1.332c2.342 0 4.24 1.926 4.24 4.334 0 2.408-1.898 4.334-4.24 4.334-2.343 0-4.239-1.926-4.239-4.334 0-2.408 1.896-4.334 4.239-4.334z",
            color: "#000",
            overflow: "visible",
            fill: "#e9574c"
        })
    );
};

exports.default = CVVIcon;

/***/ }),

/***/ 2476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlashIcon = function SlashIcon(_ref) {
    var props = (0, _objectWithoutProperties3.default)(_ref, []);
    return _react2.default.createElement(
        "svg",
        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", width: "7", height: "32", viewBox: "0 0 7 32" }, props),
        _react2.default.createElement("path", { fill: "none", stroke: "#979797", strokeLinecap: "square", d: "M6.5.5l-6 32" })
    );
};

exports.default = SlashIcon;

/***/ }),

/***/ 2477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__(9);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _AddressLineOne = __webpack_require__(276);

var _AddressLineOne2 = _interopRequireDefault(_AddressLineOne);

var _AddressLineTwo = __webpack_require__(983);

var _AddressLineTwo2 = _interopRequireDefault(_AddressLineTwo);

var _AddressLineThree = __webpack_require__(984);

var _AddressLineThree2 = _interopRequireDefault(_AddressLineThree);

var _TownCity = __webpack_require__(985);

var _TownCity2 = _interopRequireDefault(_TownCity);

var _Postcode = __webpack_require__(986);

var _Postcode2 = _interopRequireDefault(_Postcode);

var _Country = __webpack_require__(987);

var _Country2 = _interopRequireDefault(_Country);

var _PostCodeLookUp = __webpack_require__(988);

var _PostCodeLookUp2 = _interopRequireDefault(_PostCodeLookUp);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStateFromStores = function getStateFromStores() {
    return {
        isMobile: _DimensionsStore2.default.isMobileWidth()
    };
};

var BillingAddress = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(BillingAddress, _React$PureComponent);

    function BillingAddress() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BillingAddress);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.defaultProps = {
            canUseDeliveryAddress: false,
            className: '',
            form: null,
            isSubForm: false,
            onAddressSelected: _noop3.default,
            onUseDeliveryAddress: _noop3.default
        }, _this.state = {
            showAddressFields: false
        }, _this.updateShowAddressFields = function (value) {
            _this.setState((0, _extends3.default)({}, _this.state, { showAddressFields: value }));
        }, _this.handleSelectAddress = function (address) {
            _this.updateShowAddressFields(true);

            _this.props.onAddressSelected(address);
        }, _this.handleToggleShowAddress = function () {
            _this.updateShowAddressFields(!_this.state.showAddressFields);
        }, _this.handleClearAddress = function () {
            _this.props.onAddressSelected(new _Address2.default());
        }, _this.handleOnUseDeliveryAddress = function () {
            _this.props.onUseDeliveryAddress();

            _this.updateShowAddressFields(true);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    BillingAddress.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.alwaysShowAddressFields !== this.props.alwaysShowAddressFields) {
            if (this.props.alwaysShowAddressFields) {
                this.updateShowAddressFields(true);
            }
        }
    };

    BillingAddress.prototype.render = function render() {
        var _props = this.props,
            alwaysShowAddressFields = _props.alwaysShowAddressFields,
            canUseDeliveryAddress = _props.canUseDeliveryAddress,
            className = _props.className,
            form = _props.form,
            isMobile = _props.isMobile,
            isSubForm = _props.isSubForm,
            outsideLabel = _props.outsideLabel;
        var showAddressFields = this.state.showAddressFields;


        var Wrapper = isSubForm ? 'div' : 'form';

        var displayAddressFields = showAddressFields || alwaysShowAddressFields;

        var colWidth = outsideLabel && !isMobile ? 6 : 12;

        return _react2.default.createElement(
            Wrapper,
            { className: (0, _classnames2.default)('billing-address', className) },
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    _react2.default.createElement(
                        'h3',
                        { className: 'payment__section-header' },
                        (0, _I18n.translate)('payment.billingAddress')
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    canUseDeliveryAddress && _react2.default.createElement(
                        _Button2.default,
                        { onClick: this.handleOnUseDeliveryAddress, className: 'margin-bottom--sm' },
                        _react2.default.createElement(_Icon2.default, { icon: 'chevron' }),
                        (0, _I18n.translate)('payment.billingAddress.useShippingAddress')
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            _Row2.default,
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 12, className: outsideLabel ? "billing-address--outside-label" : "" },
                                _react2.default.createElement(_PostCodeLookUp2.default, {
                                    country: form.get('country'),
                                    onSelectAddress: this.handleSelectAddress,
                                    cols: { md: 12 },
                                    outsideLabel: outsideLabel }),
                                outsideLabel && !displayAddressFields && _react2.default.createElement(
                                    'div',
                                    { className: 'manual-address-btn' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        {
                                            className: 'btn-link',
                                            onClick: this.handleToggleShowAddress
                                        },
                                        (0, _I18n.translate)("address.enterManually")
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _Row2.default,
                            { className: 'margin-bottom--sm' },
                            !outsideLabel && _react2.default.createElement(
                                _Col2.default,
                                { xs: 12, md: 6 },
                                !displayAddressFields && _react2.default.createElement(
                                    'div',
                                    { className: 'manual-address-btn' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        {
                                            className: 'btn-link',
                                            onClick: this.handleToggleShowAddress
                                        },
                                        (0, _I18n.translate)("address.enterManually")
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 12 },
                                displayAddressFields && _react2.default.createElement(
                                    _Button2.default,
                                    {
                                        bsStyle: 'default',
                                        className: 'btn-default pull-right',
                                        onClick: this.handleClearAddress
                                    },
                                    (0, _I18n.translate)("address.clearAddress")
                                )
                            )
                        )
                    )
                ),
                displayAddressFields && _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_AddressLineOne2.default, (0, _extends3.default)({}, this.props, { required: true }))
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_AddressLineTwo2.default, this.props)
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_AddressLineThree2.default, this.props)
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_TownCity2.default, (0, _extends3.default)({}, this.props, { required: true }))
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_Postcode2.default, (0, _extends3.default)({}, this.props, { required: true }))
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_Country2.default, (0, _extends3.default)({}, this.props, { required: true }))
                    )
                )
            )
        );
    };

    return BillingAddress;
}(_react2.default.PureComponent), _class.propTypes = (0, _extends3.default)({
    alwaysShowAddressFields: _propTypes2.default.bool,
    canUseDeliveryAddress: _propTypes2.default.bool,
    form: _propTypes2.default.object,
    isSubForm: _propTypes2.default.bool,
    onAddressSelected: _propTypes2.default.func,
    onUseDeliveryAddress: _propTypes2.default.func
}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'disabled', 'outsideLabel', 'visited', 'validation']), {
    className: _propTypes2.default.string
}), _temp2);
exports.default = (0, _connectToStores2.default)([_DimensionsStore2.default], getStateFromStores)(BillingAddress);

/***/ }),

/***/ 2478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CocsResponse = __webpack_require__(1031);

var _CocsResponse2 = _interopRequireDefault(_CocsResponse);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _APIClient = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThreeDSecure = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(ThreeDSecure, _PureRenderComponent);

    function ThreeDSecure() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ThreeDSecure);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.formRef = _react2.default.createRef(), _this._handleComplete = function (_ref) {
            var origin = _ref.origin,
                data = _ref.data;

            if (window.location.href.includes(origin.replace(/^https?:/, '')) && data === 'complete') {
                _this.props.onComplete();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    ThreeDSecure.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        window.addEventListener('message', this._handleComplete);
    };

    ThreeDSecure.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('message', this._handleComplete);
    };

    ThreeDSecure.prototype.componentDidMount = function componentDidMount() {
        // Once rendered onto the page, we submit the
        // 3DSecure form through the iframe immediately
        this.formRef.current.submit();
    };

    ThreeDSecure.prototype.render = function render() {
        var _props = this.props,
            authResponse = _props.authResponse,
            currentOrder = _props.currentOrder,
            isOrderAmendment = _props.isOrderAmendment,
            responseUrl = _props.responseUrl;

        var isThreeDSecureV2 = !!authResponse.threeDSServerTransId;

        var host = window.location.host;

        var callbackUrl = _config2.default.get('threeDSecureCallbackUrl');

        var threeDSecureTermUrl = isThreeDSecureV2 ? _config2.default.get('threeDSecureTermUrlV2Payment') : _config2.default.get('threeDSecureTermUrlV1Payment');

        var responseUrlValue = isOrderAmendment ? (0, _APIClient.makeUrl)(threeDSecureTermUrl.replace('{orderId}', currentOrder.id).replace('{paymentId}', authResponse.id).replace('{deviceToken}', this.props.deviceToken).replace('{callbackUrl}', 'https://' + host + callbackUrl)) : responseUrl;

        return _react2.default.createElement(
            'form',
            {
                className: 'embed-responsive threed-secure',
                ref: this.formRef,
                action: authResponse.redirect,
                method: 'POST',
                target: 'iframe'
            },
            _react2.default.createElement('iframe', { ref: 'iframe', name: 'iframe', className: 'js-3ds-iframe', frameBorder: '0' }),
            isThreeDSecureV2 ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement('input', {
                    type: 'hidden',
                    name: 'transactionId',
                    value: authResponse.threeDSServerTransId
                }),
                _react2.default.createElement('input', { type: 'hidden', name: 'notificationUrl', value: responseUrlValue }),
                _react2.default.createElement('input', { type: 'hidden', name: 'MD', value: authResponse.md })
            ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement('input', { type: 'hidden', name: 'PaReq', value: authResponse.pareq }),
                _react2.default.createElement('input', { type: 'hidden', name: 'MD', value: authResponse.md }),
                _react2.default.createElement('input', { type: 'hidden', name: 'TermUrl', value: responseUrlValue })
            )
        );
    };

    return ThreeDSecure;
}(_PureRenderComponent3.default), _class.propTypes = {
    authResponse: _propTypes2.default.instanceOf(_CocsResponse2.default).isRequired,
    deviceToken: _propTypes2.default.string,
    currentOrder: _propTypes2.default.instanceOf(_Order2.default),
    responseUrl: _propTypes2.default.string.isRequired,
    onComplete: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = ThreeDSecure;

/***/ }),

/***/ 2516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ThreeDSecureType = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keymirror = __webpack_require__(176);

var _keymirror2 = _interopRequireDefault(_keymirror);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _PaymentStore = __webpack_require__(418);

var _PaymentStore2 = _interopRequireDefault(_PaymentStore);

var _ThreeDSecure = __webpack_require__(2478);

var _ThreeDSecure2 = _interopRequireDefault(_ThreeDSecure);

var _TokenStore = __webpack_require__(281);

var _TokenStore2 = _interopRequireDefault(_TokenStore);

var _APIClient = __webpack_require__(52);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThreeDSecureType = exports.ThreeDSecureType = (0, _keymirror2.default)({
    Payment: null,
    Authorization: null
});

var with3DSecure = function with3DSecure(type) {
    return function (WrappedComponent) {
        var _dec, _class, _class2, _temp2;

        var _getStateFromStores = function _getStateFromStores() {
            return {
                currentOrder: _OrderStore2.default.getCurrent(),
                is3DSecure: _PaymentStore2.default.is3DSecure()
            };
        };

        var With3DSecure = (_dec = (0, _connectToStores2.default)([_OrderStore2.default, _PaymentStore2.default], _getStateFromStores), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
            (0, _inherits3.default)(With3DSecure, _React$PureComponent);

            function With3DSecure() {
                var _temp, _this, _ret;

                (0, _classCallCheck3.default)(this, With3DSecure);

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handle3DSComplete = function (handlePaymentComplete, options) {
                    return function () {
                        if (options) {
                            // handle keyGo here
                            if (options.isKeyGo) {
                                handlePaymentComplete({ justReset3D: true });
                            }
                            if (options.isKeyGoRegistration) {
                                _CustomerActions2.default.registerKeyGoResume(options.user, options.threeDSecureAuthResponse.cocs.id);
                            } else {
                                // can only be registration or update
                                _CustomerActions2.default.updateKeyGoResume(options.user, options.threeDSecureAuthResponse.cocs.id);
                            }
                            if (options && options.successCallback) {
                                options.successCallback();
                            }
                        } else {
                            _OrderActions2.default.refresh(_this.props.currentOrder).then(handlePaymentComplete);
                        }
                    };
                }, _this._getThreeDSecureProps = function (authResponse, handler, opts) {
                    var host = window.location.host;

                    var callbackUrl = _config2.default.get('threeDSecureCallbackUrl');
                    var threeDSecureTermUrl = _config2.default.get('threeDSecureTermUrl' + (authResponse.cocs.threeDSServerTransId ? 'V2' : 'V1') + type);

                    switch (type) {
                        case ThreeDSecureType.Payment:
                            {
                                return {
                                    authResponse: authResponse.cocs,
                                    onComplete: _this._handle3DSComplete(handler, opts),
                                    responseUrl: (0, _APIClient.makeUrl)(threeDSecureTermUrl.replace('{orderId}', _this.props.currentOrder.id).replace('{paymentId}', authResponse.id).replace('{deviceToken}', _TokenStore2.default.getDevice()).replace('{callbackUrl}', 'https://' + host + callbackUrl))
                                };
                            }

                        case ThreeDSecureType.Authorization:
                            {
                                return {
                                    authResponse: authResponse.cocs,
                                    onComplete: _this._handle3DSComplete(handler, opts),
                                    responseUrl: (0, _APIClient.makeUrl)(threeDSecureTermUrl.replace('{paymentId}', authResponse.id).replace('{callbackUrl}', 'https://' + host + callbackUrl))
                                };
                            }

                        default:
                            {
                                return null;
                            }
                    }
                }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
            }

            With3DSecure.prototype.render = function render() {
                var _this2 = this;

                var injectedProps = {
                    handle3DSComplete: this._handle3DSComplete,
                    renderThreeDSecure: function renderThreeDSecure() {
                        return _react2.default.createElement(_ThreeDSecure2.default, _this2._getThreeDSecureProps.apply(_this2, arguments));
                    }
                };

                return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, injectedProps, this.props));
            };

            return With3DSecure;
        }(_react2.default.PureComponent), _class2.propTypes = {
            currentOrder: _propTypes2.default.instanceOf(_Order2.default).isRequired
        }, _temp2)) || _class);


        With3DSecure.displayName = 'With3DSecure(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')';

        return With3DSecure;
    };
};

exports.default = with3DSecure;

/***/ }),

/***/ 2557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _KeyGoForm = __webpack_require__(978);

var _KeyGoForm2 = _interopRequireDefault(_KeyGoForm);

var _I18n = __webpack_require__(9);

var _CardDetails = __webpack_require__(2466);

var _CardDetails2 = _interopRequireDefault(_CardDetails);

var _BillingAddress = __webpack_require__(2477);

var _BillingAddress2 = _interopRequireDefault(_BillingAddress);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _CollectionStation = __webpack_require__(2572);

var _CollectionStation2 = _interopRequireDefault(_CollectionStation);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _SignupTAndCs = __webpack_require__(594);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmartcardPayment = function SmartcardPayment(_ref) {
    var form = _ref.form,
        validation = _ref.validation,
        visited = _ref.visited,
        onChange = _ref.onChange,
        onAddressSelected = _ref.onAddressSelected,
        isUpdate = _ref.isUpdate,
        collectionLocationRequired = _ref.collectionLocationRequired;
    return _react2.default.createElement(
        'div',
        { className: 'payment-form keygo-card-details' },
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { md: 7, lg: 8, className: 'margin-bottom--sm' },
                    _react2.default.createElement(_FormattedHTMLMessage2.default, {
                        message: 'account.smartcard.keygo.cardTypes',
                        keygobrand: _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' })
                    })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { md: 5, lg: 4 },
                    _react2.default.createElement(
                        'ul',
                        { className: 'card-type-list text-center' },
                        _react2.default.createElement(
                            'li',
                            { className: 'card-type--visa' },
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                (0, _I18n.translate)('payment.cardType.visa')
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'card-type--mastercard' },
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                (0, _I18n.translate)('payment.cardType.mastercard')
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'card-type--amex' },
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                (0, _I18n.translate)('payment.cardType.amex')
                            )
                        )
                    )
                )
            )
        ),
        isUpdate && _react2.default.createElement(
            'h4',
            { className: 'text-weight--normal text-primary' },
            (0, _I18n.translate)('account.smartcard.keygo.updatePayment')
        ),
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'account.smartcard.keygo.details.' + (isUpdate ? 'reminder' : '1'),
            splitParagraphs: true
        }),
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'account.smartcard.keygo.details.2',
            tagName: 'ul',
            className: 'list-styled',
            splitParagraphs: true,
            paragraphTagName: 'li'
        }),
        _react2.default.createElement(
            'div',
            { className: 'alert-required margin-top' },
            _react2.default.createElement(_Icon2.default, { icon: 'mandatory' }),
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n.translate)('required.fields')
            )
        ),
        collectionLocationRequired && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement('br', null),
            _react2.default.createElement(_CollectionStation2.default, {
                form: form,
                validation: validation,
                visited: visited,
                onChange: onChange,
                isKeyGo: true,
                required: true
            })
        ),
        _react2.default.createElement(
            'h3',
            { className: 'payment__section-header' },
            (0, _I18n.translate)('account.smartcard.keygo.cardDetails')
        ),
        _react2.default.createElement(_CardDetails2.default, {
            form: form,
            validation: validation,
            visited: visited,
            onChange: onChange
        }),
        _react2.default.createElement(_BillingAddress2.default, {
            className: 'border--bottom',
            form: form,
            validation: validation,
            visited: visited,
            onChange: onChange,
            onAddressSelected: onAddressSelected,
            alwaysShowAddressFields: visited,
            outsideLabel: true
        }),
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'account.smartcard.keygo.byContinuingYouAccept',
            termsAndConditions: _react2.default.createElement(_SignupTAndCs.TermsAndConditionsLink, {
                message: (0, _I18n.translate)('form.keyGoTermsAndConditions'),
                url: _config2.default.get('keyGoTermsAndConditionsUrl')
            })
        })
    );
};

SmartcardPayment.propTypes = {
    form: _propTypes2.default.instanceOf(_KeyGoForm2.default).isRequired,
    validation: _propTypes2.default.object.isRequired,
    visited: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onAddressSelected: _propTypes2.default.func.isRequired,
    isUpdate: _propTypes2.default.bool,
    collectionLocationRequired: _propTypes2.default.bool
};

SmartcardPayment.defaultProps = {
    visited: false,
    isUpdate: false,
    collectionLocationRequired: false
};

exports.default = SmartcardPayment;

/***/ }),

/***/ 2567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Loading = __webpack_require__(274);

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeftColumn(_ref) {
    var loading = _ref.loading,
        children = _ref.children,
        className = _ref.className;

    if (loading) {
        return _react2.default.createElement(_Loading2.default, { message: (0, _I18n.translate)('booking.loading.results') });
    }

    return _react2.default.createElement(
        'div',
        { className: 'left-col ' + className },
        children
    );
}

LeftColumn.propTypes = {
    loading: _propTypes2.default.bool,
    children: _propTypes2.default.any,
    className: _propTypes2.default.string
};

exports.default = LeftColumn;

/***/ }),

/***/ 2568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _KeyGoForm = __webpack_require__(978);

var _KeyGoForm2 = _interopRequireDefault(_KeyGoForm);

var _Payment = __webpack_require__(423);

var _Smartcard3 = __webpack_require__(336);

var _Breadcrumb = __webpack_require__(2179);

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _FormWrapper = __webpack_require__(613);

var _FormWrapper2 = _interopRequireDefault(_FormWrapper);

var _Error = __webpack_require__(2569);

var _Error2 = _interopRequireDefault(_Error);

var _Success = __webpack_require__(2570);

var _Success2 = _interopRequireDefault(_Success);

var _Form = __webpack_require__(2571);

var _Form2 = _interopRequireDefault(_Form);

var _with3DSecure = __webpack_require__(2516);

var _with3DSecure2 = _interopRequireDefault(_with3DSecure);

var _AuthResponse = __webpack_require__(607);

var _AuthResponse2 = _interopRequireDefault(_AuthResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyGoRegistration = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(KeyGoRegistration, _PureRenderComponent);

    function KeyGoRegistration() {
        (0, _classCallCheck3.default)(this, KeyGoRegistration);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    KeyGoRegistration.prototype.render = function render() {
        var _props = this.props,
            error = _props.error,
            paymentSucceeded = _props.paymentSucceeded,
            smartcard = _props.smartcard,
            form = _props.form,
            validation = _props.validation,
            hasSmartcardInSingleStep = _props.hasSmartcardInSingleStep,
            isReplacementPending = _props.isReplacementPending,
            isSingleStepSmartcardRegistration = _props.isSingleStepSmartcardRegistration,
            formInvalid = _props.formInvalid,
            handleFormChange = _props.handleFormChange,
            handleRetry = _props.handleRetry,
            enableSameAsDeliveryAddress = _props.enableSameAsDeliveryAddress,
            onChangeUseDeliveryAddress = _props.onChangeUseDeliveryAddress,
            submitted = _props.submitted,
            renderThreeDSecure = _props.renderThreeDSecure,
            threeDSecureAuthResponse = _props.threeDSecureAuthResponse,
            handleRegisterKeyGo = _props.handleRegisterKeyGo,
            user = _props.user;


        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                _Row2.default,
                null,
                !isSingleStepSmartcardRegistration && _react2.default.createElement(_Breadcrumb2.default, { pageName: (0, _I18n.translate)('account.nav.smartcard.keygoaccount') }),
                _react2.default.createElement(
                    _Col2.default,
                    {
                        md: isSingleStepSmartcardRegistration ? 12 : 10,
                        mdOffset: isSingleStepSmartcardRegistration ? 0 : 1,
                        lg: isSingleStepSmartcardRegistration ? 12 : 10,
                        lgOffset: isSingleStepSmartcardRegistration ? 0 : 1,
                        className: (0, _classnames2.default)('account', {
                            'margin-bottom': !isSingleStepSmartcardRegistration
                        })
                    },
                    error && _react2.default.createElement(_Error2.default, { error: error, handleRetry: handleRetry }),
                    paymentSucceeded && _react2.default.createElement(_Success2.default, null),
                    !error && !paymentSucceeded && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _FormWrapper2.default,
                            { submitted: submitted },
                            _react2.default.createElement(_Form2.default, {
                                smartcard: smartcard,
                                form: form,
                                validation: validation,
                                hasSmartcardInSingleStep: hasSmartcardInSingleStep,
                                isReplacementPending: isReplacementPending,
                                isSingleStepSmartcardRegistration: isSingleStepSmartcardRegistration,
                                formInvalid: formInvalid,
                                handleFormChange: handleFormChange,
                                enableSameAsDeliveryAddress: enableSameAsDeliveryAddress,
                                onChangeUseDeliveryAddress: onChangeUseDeliveryAddress
                            })
                        )
                    )
                )
            ),
            _react2.default.createElement(
                _Row2.default,
                null,
                threeDSecureAuthResponse && _react2.default.createElement(
                    _Col2.default,
                    {
                        md: isSingleStepSmartcardRegistration ? 12 : 10,
                        mdOffset: isSingleStepSmartcardRegistration ? 0 : 1,
                        lg: isSingleStepSmartcardRegistration ? 12 : 10,
                        lgOffset: isSingleStepSmartcardRegistration ? 0 : 1,
                        className: 'margin-bottom'
                    },
                    renderThreeDSecure(threeDSecureAuthResponse, handleRegisterKeyGo, {
                        isKeyGo: true,
                        isKeyGoRegistration: true,
                        isKeyGoUpdate: false,
                        user: user,
                        threeDSecureAuthResponse: threeDSecureAuthResponse
                    })
                )
            )
        );
    };

    return KeyGoRegistration;
}(_PureRenderComponent3.default), _class.propTypes = {
    error: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Payment.PaymentUnauthorizedError), _propTypes2.default.instanceOf(_Smartcard3.ACTError)]),
    paymentSucceeded: _propTypes2.default.bool,
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default).isRequired,
    form: _propTypes2.default.instanceOf(_KeyGoForm2.default).isRequired,
    validation: _propTypes2.default.object.isRequired,
    isReplacementPending: _propTypes2.default.bool,
    isSingleStepSmartcardRegistration: _propTypes2.default.bool,
    hasSmartcardInSingleStep: _propTypes2.default.bool,
    formInvalid: _propTypes2.default.bool,
    handleFormChange: _propTypes2.default.func.isRequired,
    handleRetry: _propTypes2.default.func.isRequired,
    enableSameAsDeliveryAddress: _propTypes2.default.bool,
    onChangeUseDeliveryAddress: _propTypes2.default.func,
    submitted: _propTypes2.default.bool,
    renderThreeDSecure: _propTypes2.default.func.isRequired,
    handleRegisterKeyGo: _propTypes2.default.func.isRequired,
    threeDSecureAuthResponse: _propTypes2.default.instanceOf(_AuthResponse2.default)
}, _temp);
exports.default = (0, _with3DSecure2.default)(_with3DSecure.ThreeDSecureType.Authorization)(KeyGoRegistration);

/***/ }),

/***/ 2569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Payment = __webpack_require__(423);

var _Smartcard = __webpack_require__(336);

var _PaymentError = __webpack_require__(2431);

var _PaymentError2 = _interopRequireDefault(_PaymentError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Error(_ref) {
    var error = _ref.error,
        handleRetry = _ref.handleRetry;

    return _react2.default.createElement(
        _Row2.default,
        null,
        _react2.default.createElement(
            _Col2.default,
            { md: 6, mdOffset: 3 },
            _react2.default.createElement(
                'div',
                { className: 'margin-top margin-bottom' },
                _react2.default.createElement(_PaymentError2.default, {
                    error: error,
                    onRetry: handleRetry
                })
            )
        )
    );
}

Error.propTypes = {
    error: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Payment.PaymentUnauthorizedError), _propTypes2.default.instanceOf(_Smartcard.ACTError)]),
    handleRetry: _propTypes2.default.func.isRequired
};

exports.default = Error;

/***/ }),

/***/ 2570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _CollectionStationsStore = __webpack_require__(1008);

var _CollectionStationsStore2 = _interopRequireDefault(_CollectionStationsStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores() {
    return {
        location: _CollectionStationsStore2.default.getSelectedLocationName()
    };
}

function Success(_ref) {
    var location = _ref.location;

    return _react2.default.createElement(
        'div',
        { className: 'padding-top padding-bottom' },
        _react2.default.createElement(
            'div',
            { className: 'confirmation text-center' },
            _react2.default.createElement(_Icon2.default, { icon: 'selected margin-bottom--sm otrl-xl' }),
            _react2.default.createElement(
                'p',
                { className: 'text-weight--normal alert-success' },
                (0, _I18n.translate)('confirmation.keygo.success')
            ),
            location && _react2.default.createElement(
                'p',
                { className: 'text-center text-weight--normal' },
                _react2.default.createElement(_FormattedHTMLMessage2.default, {
                    message: 'account.smartcard.keygo.ready',
                    location: location,
                    keygobrand: _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' })
                })
            ),
            !location && _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'enableKeyGoCollectionInfo' },
                _react2.default.createElement(
                    'p',
                    { className: 'text-center text-weight--normal' },
                    _react2.default.createElement(_FormattedHTMLMessage2.default, {
                        message: 'account.smartcard.keygo.collect.info',
                        keygobrand: _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' })
                    })
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'text-center text-weight--normal' },
                    _react2.default.createElement(_ExternalLink2.default, {
                        message: (0, _I18n.translate)('account.smartcard.keygo.collect.map', {
                            keygobrand: (0, _I18n.translate)('account.smartcard.text.keygo')
                        }),
                        href: _config2.default.get('keyGoCollectionMapUrl')
                    })
                )
            )
        )
    );
}

Success.propTypes = {
    location: _propTypes2.default.string
};

Success.defaultProps = {
    location: null
};

exports.default = (0, _connectToStores2.default)([_CollectionStationsStore2.default], _getStateFromStores)(Success);

/***/ }),

/***/ 2571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _KeyGoForm = __webpack_require__(978);

var _KeyGoForm2 = _interopRequireDefault(_KeyGoForm);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _SmartcardPayment = __webpack_require__(2557);

var _SmartcardPayment2 = _interopRequireDefault(_SmartcardPayment);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _SmartcardReplacementWarning = __webpack_require__(2442);

var _SmartcardReplacementWarning2 = _interopRequireDefault(_SmartcardReplacementWarning);

var _KeyGoInformation = __webpack_require__(2574);

var _KeyGoInformation2 = _interopRequireDefault(_KeyGoInformation);

var _KeyGoNotAvailable = __webpack_require__(2575);

var _KeyGoNotAvailable2 = _interopRequireDefault(_KeyGoNotAvailable);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Form(props) {
    var smartcard = props.smartcard,
        form = props.form,
        validation = props.validation,
        isReplacementPending = props.isReplacementPending,
        formInvalid = props.formInvalid,
        handleFormChange = props.handleFormChange,
        enableKeyGoMinTopup = props.enableKeyGoMinTopup,
        isSingleStepSmartcardRegistration = props.isSingleStepSmartcardRegistration,
        enableSameAsDeliveryAddress = props.enableSameAsDeliveryAddress,
        onChangeUseDeliveryAddress = props.onChangeUseDeliveryAddress,
        hasSmartcardInSingleStep = props.hasSmartcardInSingleStep;


    if (isReplacementPending) {
        return _react2.default.createElement(_SmartcardReplacementWarning2.default, null);
    }

    if (!isSingleStepSmartcardRegistration && !smartcard.canLoadProduct()) {
        return _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12 },
                _react2.default.createElement(
                    _KeyGoInformation2.default,
                    null,
                    _react2.default.createElement(_KeyGoNotAvailable2.default, { smartcard: smartcard })
                )
            )
        );
    }

    return _react2.default.createElement(
        'div',
        null,
        !isSingleStepSmartcardRegistration && _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12 },
                _react2.default.createElement(_KeyGoInformation2.default, { enableKeyGoMinTopup: enableKeyGoMinTopup })
            )
        ),
        _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12 },
                _react2.default.createElement(
                    'div',
                    { className: 'margin-top--sm padding-bottom--sm' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'text-weight--normal keygo-registration__title' },
                        _react2.default.createElement(_FormattedHTMLMessage2.default, {
                            message: 'account.smartcard.keygo.add',
                            keygobrand: _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' })
                        })
                    ),
                    _react2.default.createElement(
                        'h4',
                        { className: 'text-weight--normal text-primary' },
                        (0, _I18n.translate)('account.smartcard.keygo.' + (enableKeyGoMinTopup ? 'minimumTopup' : 'noTopup'))
                    ),
                    _react2.default.createElement(_SmartcardPayment2.default, {
                        form: form,
                        onChange: handleFormChange,
                        validation: validation,
                        visited: formInvalid,
                        onAddressSelected: _CustomerActions2.default.keyGoFormAddressSelected,
                        collectionLocationRequired: (!isSingleStepSmartcardRegistration || hasSmartcardInSingleStep) && !smartcard.isAwaitingProduct(),
                        enableSameAsDeliveryAddress: enableSameAsDeliveryAddress,
                        onChangeUseDeliveryAddress: onChangeUseDeliveryAddress })
                )
            )
        )
    );
}

Form.propTypes = {
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default).isRequired,
    form: _propTypes2.default.instanceOf(_KeyGoForm2.default),
    validation: _propTypes2.default.object,
    isReplacementPending: _propTypes2.default.bool,
    formInvalid: _propTypes2.default.bool,
    handleFormChange: _propTypes2.default.func.isRequired,
    enableKeyGoMinTopup: _propTypes2.default.bool,
    hasSmartcardInSingleStep: _propTypes2.default.bool,
    isSingleStepSmartcardRegistration: _propTypes2.default.bool,
    enableSameAsDeliveryAddress: _propTypes2.default.bool,
    onChangeUseDeliveryAddress: _propTypes2.default.func
};

function getStateFromStores() {
    return {
        enableKeyGoMinTopup: _FeatureFlagStore2.default.get('enableKeyGoMinTopup')
    };
}

exports.default = (0, _connectToStores2.default)([_FeatureFlagStore2.default], getStateFromStores)(Form);

/***/ }),

/***/ 2572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _CollectionStationsStore = __webpack_require__(1008);

var _CollectionStationsStore2 = _interopRequireDefault(_CollectionStationsStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _CollectionStationsActions = __webpack_require__(2573);

var _CollectionStationsActions2 = _interopRequireDefault(_CollectionStationsActions);

var _I18n = __webpack_require__(9);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores() {
    return {
        collectionStations: _CollectionStationsStore2.default.get('stations'),
        isLoading: _CollectionStationsStore2.default.get('loading')
    };
}

var CollectionStation = (_dec = (0, _connectToStores2.default)([_CollectionStationsStore2.default], _getStateFromStores), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(CollectionStation, _React$PureComponent);

    function CollectionStation() {
        (0, _classCallCheck3.default)(this, CollectionStation);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    CollectionStation.prototype.componentDidMount = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _CollectionStationsActions2.default.get();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function componentDidMount() {
            return _ref.apply(this, arguments);
        }

        return componentDidMount;
    }();

    CollectionStation.prototype.render = function render() {
        var _props = this.props,
            isKeyGo = _props.isKeyGo,
            isSubForm = _props.isSubForm,
            form = _props.form,
            onChange = _props.onChange,
            disabled = _props.disabled,
            visited = _props.visited,
            validation = _props.validation,
            collectionStations = _props.collectionStations,
            required = _props.required;

        var Wrapper = isSubForm ? 'div' : 'form';
        var outsideLabelProp = isKeyGo ? { outsideLabel: true } : null;

        return _react2.default.createElement(
            Wrapper,
            { className: 'collection-location' },
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    _react2.default.createElement(
                        _ValidatedField2.default,
                        (0, _extends3.default)({ form: form, onChange: onChange, disabled: disabled, visited: visited, validation: validation, required: required }, {
                            type: 'select',
                            id: 'collectionLocation',
                            field: 'collectionLocation',
                            groupClassName: 'select-container margin-bottom--sm',
                            label: (0, _I18n.translate)('account.register.loadingStation.fieldLabel'),
                            placeholder: (0, _I18n.translate)('account.register.loadingStation.fieldLabel'),
                            labelClassName: 'sr-only'
                        }, outsideLabelProp),
                        _react2.default.createElement(
                            'option',
                            { value: '' },
                            (0, _I18n.translate)('account.register.loadingStation.fieldPlaceholder')
                        ),
                        collectionStations.map(function (station) {
                            return _react2.default.createElement(
                                'option',
                                { key: station.nlc, value: station.nlc },
                                station.get('name')
                            );
                        })
                    )
                )
            ),
            _react2.default.createElement(
                'p',
                { className: isKeyGo ? 'border--bottom margin-bottom padding-bottom--sm' : '' },
                isKeyGo ? _react2.default.createElement(_FormattedHTMLMessage2.default, {
                    className: 'text-size--normal text-weight--bold',
                    message: 'account.smartcard.keygo.loadingStation',
                    findMoreLink: _react2.default.createElement(_ExternalLink2.default, {
                        message: (0, _I18n.translate)('account.smartcard.keygo.loadingStation.findMore'),
                        href: _config2.default.get('keyGoInformationUrl')
                    })
                }) : (0, _I18n.translate)('account.register.loadingStation.fieldDescription')
            )
        );
    };

    return CollectionStation;
}(_react2.default.PureComponent), _class2.propTypes = {
    isSubForm: _propTypes2.default.bool,
    required: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    collectionStations: _propTypes2.default.instanceOf(_immutable.List),
    visited: _propTypes2.default.bool,
    validation: _propTypes2.default.object,
    form: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_immutable.Record), _propTypes2.default.object]).isRequired,
    onChange: _propTypes2.default.func.isRequired,
    disabled: _propTypes2.default.bool,
    isKeyGo: _propTypes2.default.bool
}, _class2.defaultProps = {
    isLoading: false,
    collectionStations: new _immutable.List(),
    isSubForm: false,
    required: false,
    visited: false,
    disabled: false,
    validation: {}
}, _temp)) || _class);
exports.default = CollectionStation;

/***/ }),

/***/ 2573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _KeyGoService = __webpack_require__(1020);

var _KeyGoService2 = _interopRequireDefault(_KeyGoService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionStationsActions = {
    get: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var stations;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.GET_COLLECTION_STATIONS_STARTED });
                            _context.prev = 1;
                            _context.next = 4;
                            return _KeyGoService2.default.getCollectionLocations();

                        case 4:
                            stations = _context.sent;

                            _AppDispatcher2.default.dispatch({
                                stations: stations,
                                actionType: _AppConstants.ActionTypes.GET_COLLECTION_STATIONS_ENDED
                            });
                            return _context.abrupt('return', stations);

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](1);

                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.GET_COLLECTION_STATIONS_FAILED, error: _context.t0 });
                            throw _context.t0;

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 9]]);
        }));

        function get() {
            return _ref.apply(this, arguments);
        }

        return get;
    }()
};

exports.default = CollectionStationsActions;

/***/ }),

/***/ 2574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function KeyGoInformation(_ref) {
    var enableKeyGoMinTopup = _ref.enableKeyGoMinTopup,
        children = _ref.children;

    var topUpMessage = enableKeyGoMinTopup ? _react2.default.createElement(
        'p',
        null,
        (0, _I18n.translate)('account.smartcard.keygo.routes')
    ) : _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'p',
            null,
            (0, _I18n.translate)('account.smartcard.keygo.details')
        ),
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'account.smartcard.keygo.moreDetails',
            learnMoreLink: _react2.default.createElement(_ExternalLink2.default, {
                message: (0, _I18n.translate)('account.smartcard.keygo.moreDetails.link'),
                href: _config2.default.get('keyGoInformationUrl')
            })
        })
    );

    return _react2.default.createElement(
        'div',
        { className: 'margin-top' },
        _react2.default.createElement(
            'div',
            { className: 'padding-bottom--sm border--bottom' },
            children,
            topUpMessage
        )
    );
}

KeyGoInformation.propTypes = {
    children: _propTypes2.default.any,
    enableKeyGoMinTopup: _propTypes2.default.bool
};

exports.default = KeyGoInformation;

/***/ }),

/***/ 2575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function KeyGoNotAvailable(_ref) {
    var smartcard = _ref.smartcard;

    var message = smartcard.productAvailability === 0 ? (0, _I18n.translate)('account.smartcard.keygo.cardFull') : (0, _I18n.translate)('account.smartcard.keygo.cardBusy');
    return _react2.default.createElement(
        'p',
        { className: 'alert-danger' },
        _react2.default.createElement(_Icon2.default, { icon: 'error', className: 'otrl-inline' }),
        ' ',
        _react2.default.createElement(
            'span',
            { className: 'text-weight--normal' },
            (0, _I18n.translate)('account.smartcard.keygo.notAvailable')
        ),
        ' ',
        message
    );
}

KeyGoNotAvailable.propTypes = {
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default).isRequired
};

exports.default = KeyGoNotAvailable;

/***/ }),

/***/ 2616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2, _initialiseProps;

exports.getStateFromStores = getStateFromStores;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _KeyGoStore = __webpack_require__(1004);

var _KeyGoStore2 = _interopRequireDefault(_KeyGoStore);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _KeyGoForm = __webpack_require__(978);

var _KeyGoForm2 = _interopRequireDefault(_KeyGoForm);

var _Payment = __webpack_require__(423);

var _Smartcard3 = __webpack_require__(336);

var _FormComponent2 = __webpack_require__(417);

var _FormComponent3 = _interopRequireDefault(_FormComponent2);

var _TimeDelayedModal = __webpack_require__(2617);

var _TimeDelayedModal2 = _interopRequireDefault(_TimeDelayedModal);

var _Warning = __webpack_require__(2619);

var _Warning2 = _interopRequireDefault(_Warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStateFromStores() {
    return {
        form: _KeyGoStore2.default.get('form'),
        validation: _KeyGoStore2.default.get('validation'),
        error: _KeyGoStore2.default.get('error'),
        paymentSucceeded: _KeyGoStore2.default.get('paymentSucceeded'),
        enableKeyGoRegistrationWarning: _FeatureFlagStore2.default.get('enableKeyGoRegistrationWarning')
    };
}

var KeyGoRegistration = (_temp2 = _class = function (_FormComponent) {
    (0, _inherits3.default)(KeyGoRegistration, _FormComponent);

    function KeyGoRegistration() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, KeyGoRegistration);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _FormComponent.call.apply(_FormComponent, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    KeyGoRegistration.prototype.handleRetry = function handleRetry() {
        _CustomerActions2.default.retryKeyGoForm();
    };

    KeyGoRegistration.prototype.renderRegistrationWarning = function renderRegistrationWarning() {
        if (!this.state.showRegistrationWarning) {
            return false;
        }
        return _react2.default.createElement(
            _TimeDelayedModal2.default,
            { delay: 10,
                onClose: this.handleCloseWarning,
                onContinue: this.handleConfirmWarning,
                disableClose: false,
                disableEscape: false,
                continueText: 'account.smartcard.keygo.registrationWarning.confirm',
                closeText: 'button.text.cancel',
                titleText: 'account.smartcard.keygo.registrationWarning.title',
                className: 'modal--med' },
            _react2.default.createElement(_Warning2.default, null)
        );
    };

    (0, _createClass3.default)(KeyGoRegistration, [{
        key: 'isButtonDisabled',
        get: function get() {
            var _state = this.state,
                loading = _state.loading,
                formInvalid = _state.formInvalid;


            return loading || formInvalid;
        }
    }, {
        key: 'keyGoRegistrationProps',
        get: function get() {
            var formInvalid = this.state.formInvalid;
            var _props = this.props,
                error = _props.error,
                paymentSucceeded = _props.paymentSucceeded,
                smartcard = _props.smartcard,
                form = _props.form,
                validation = _props.validation,
                isReplacementPending = _props.isReplacementPending,
                user = _props.user;


            return {
                error: error,
                paymentSucceeded: paymentSucceeded,
                smartcard: smartcard,
                validation: validation,
                form: form,
                isReplacementPending: isReplacementPending,
                formInvalid: formInvalid,
                threeDSecureAuthResponse: this.state.threeDSecureAuthResponse,
                handleFormChange: this.handleFormChange,
                handleRetry: this.handleRetry,
                handleRegisterKeyGo: this.handleRegisterFinishedKeyGo,
                user: user
            };
        }
    }]);
    return KeyGoRegistration;
}(_FormComponent3.default), _class.propTypes = {
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default).isRequired,
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    isReplacementPending: _propTypes2.default.bool,
    form: _propTypes2.default.instanceOf(_KeyGoForm2.default),
    validation: _propTypes2.default.object,
    error: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Payment.PaymentUnauthorizedError), _propTypes2.default.instanceOf(_Smartcard3.ACTError)]),
    paymentSucceeded: _propTypes2.default.bool,
    enableKeyGoRegistrationWarning: _propTypes2.default.bool
}, _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.state = {
        loading: false,
        formInvalid: false,
        showRegistrationWarning: false,
        threeDSecureAuthResponse: null
    };

    this.checkFormFold = function (someCb) {
        var noneCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
            _this2.setState({ submitted: true, formInvalid: true });
        };
        var form = _this2.props.form;

        if (form.isComplete()) {
            someCb(form);
        } else {
            noneCb();
        }
    };

    this.handleKeyGoPay = function () {
        return _this2.checkFormFold(function () {
            var enableKeyGoRegistrationWarning = _this2.props.enableKeyGoRegistrationWarning;
            // submitted is used by FormComponent to handle scrolling

            _this2.setState({ submitted: true });

            if (enableKeyGoRegistrationWarning) {
                _this2.setState({
                    showRegistrationWarning: true
                });
            } else {
                _this2.handleRegisterKeyGo();
            }
        });
    };

    this.handleCloseWarning = function () {
        _this2.setState({ showRegistrationWarning: false });
    };

    this.handleConfirmWarning = function () {
        _this2.handleCloseWarning();
        _this2.handleRegisterKeyGo();
    };

    this.handleRegisterKeyGo = function () {
        return _this2.checkFormFold(function (form) {
            _this2.setState({ threeDSecureAuthResponse: null });
            var user = _this2.props.user;


            _this2.setState({ loading: true });
            _CustomerActions2.default.registerKeyGo(user, form).then(function (threeDSecureAuthResponse) {
                if (threeDSecureAuthResponse) {
                    _this2.setState({ threeDSecureAuthResponse: threeDSecureAuthResponse });
                }
            }).finally(function () {
                return _this2.setState({ loading: false });
            });
        });
    };

    this.handleRegisterFinishedKeyGo = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            justReset3D = _ref2.justReset3D;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!justReset3D) {
                            _CustomerActions2.default.registrationKeyGoFormComplete();
                        }

                        _this2.setState({ threeDSecureAuthResponse: null });

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this2);
    }));

    this.handleFormChange = function () {
        _this2.setState({ submitted: false, formInvalid: false });
        _CustomerActions2.default.changeKeyGoForm.apply(_CustomerActions2.default, arguments);
    };
}, _temp2);
exports.default = KeyGoRegistration;

/***/ }),

/***/ 2617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Countdown = __webpack_require__(2618);

var _Countdown2 = _interopRequireDefault(_Countdown);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _ProgressBar = __webpack_require__(641);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeDelayedModal = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(TimeDelayedModal, _React$PureComponent);

    function TimeDelayedModal() {
        (0, _classCallCheck3.default)(this, TimeDelayedModal);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    TimeDelayedModal.prototype.render = function render() {
        var _props = this.props,
            show = _props.show,
            delay = _props.delay,
            children = _props.children,
            FooterLoader = _props.footerLoader,
            modalProps = (0, _objectWithoutProperties3.default)(_props, ['show', 'delay', 'children', 'footerLoader']);

        if (!show) {
            return null;
        }

        return _react2.default.createElement(
            _Countdown2.default,
            { start: delay },
            function (_ref) {
                var timeRemaining = _ref.counter,
                    isCounting = _ref.isCounting;
                return _react2.default.createElement(
                    _BaseModal2.default,
                    (0, _extends3.default)({
                        disableClose: isCounting,
                        disableContinue: isCounting,
                        disableEscape: isCounting,
                        footerContent: isCounting ? _react2.default.createElement(FooterLoader, { completed: delay - timeRemaining, total: delay }) : null
                    }, modalProps),
                    children
                );
            }
        );
    };

    return TimeDelayedModal;
}(_react2.default.PureComponent), _class.propTypes = {
    delay: _propTypes2.default.number.isRequired,
    footerLoader: _propTypes2.default.func,
    children: _propTypes2.default.any,
    show: _propTypes2.default.bool
}, _class.defaultProps = {
    show: true,
    footerLoader: function footerLoader(_ref2) {
        var completed = _ref2.completed,
            total = _ref2.total;
        return _react2.default.createElement(
            'div',
            { className: 'countdown-progressbar margin-top--sm' },
            _react2.default.createElement(_ProgressBar2.default, { completed: completed, total: total })
        );
    }
}, _temp);
exports.default = TimeDelayedModal;

/***/ }),

/***/ 2618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Countdown = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Countdown, _React$PureComponent);

    function Countdown() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Countdown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            counter: _this.props.start
        }, _this.timer = undefined, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Countdown.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        this.startCountdown();
    };

    Countdown.prototype.componentWillUnmount = function componentWillUnmount() {
        this.stopCountdown();
    };

    Countdown.prototype.startCountdown = function startCountdown() {
        var _this2 = this;

        var counter = Math.floor(this.props.start);
        var countdown = function countdown() {
            _this2.setState({ counter: counter });
            if (counter > Math.floor(_this2.props.end)) {
                --counter;
                _this2.timer = setTimeout(countdown, 1000);
            } else {
                _this2.timer = undefined;
            }
        };

        countdown();
    };

    Countdown.prototype.stopCountdown = function stopCountdown() {
        this.timer = clearTimeout(this.timer);
        this.timer = undefined;
    };

    Countdown.prototype.render = function render() {
        var ChildComponent = this.props.children;
        var counter = this.state.counter;

        var isCounting = !!this.timer && counter > Math.floor(this.props.end);
        return _react2.default.createElement(ChildComponent, { counter: counter, isCounting: isCounting });
    };

    return Countdown;
}(_react2.default.PureComponent), _class.propTypes = {
    start: _propTypes2.default.number,
    end: _propTypes2.default.number,
    children: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
    start: 3,
    end: 0
}, _temp2);
exports.default = Countdown;

/***/ }),

/***/ 2619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = KeyGoRegistrationWarning;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function KeyGoRegistrationWarning() {
    var keygoBrand = _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' });
    return _react2.default.createElement(
        'div',
        { className: 'padding-top padding-bottom' },
        _react2.default.createElement(
            'div',
            { className: 'confirmation' },
            _react2.default.createElement(_Icon2.default, { icon: 'warning margin-bottom--sm otrl-xl text-center' }),
            _react2.default.createElement(
                'p',
                { className: 'text-weight--normal alert-warning' },
                (0, _I18n2.default)('account.smartcard.keygo.registrationWarning.title')
            ),
            _react2.default.createElement(
                _BAlert2.default,
                { type: _BAlert.bAlertType.WARNING, className: 'text-center' },
                _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.keygo.registrationWarning.alert',
                    keygobrand: keygoBrand
                })
            ),
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                splitParagraphs: true,
                paragraphTagName: 'li',
                tagName: 'ul',
                className: 'list-styled text-left text-weight--normal margin-top--sm',
                message: 'account.smartcard.keygo.registrationWarning.list',
                keygobrand: keygoBrand,
                moreDetails: _react2.default.createElement(_ExternalLink2.default, {
                    href: _config2.default.get('keyGoInformationUrl'),
                    message: 'global.here' }) })
        )
    );
}

/***/ }),

/***/ 2699:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _LeftColumn = __webpack_require__(2567);

var _LeftColumn2 = _interopRequireDefault(_LeftColumn);

var _SearchTabs = __webpack_require__(2700);

var _SearchTabs2 = _interopRequireDefault(_SearchTabs);

var _SmartcardCTA = __webpack_require__(2701);

var _SmartcardCTA2 = _interopRequireDefault(_SmartcardCTA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchLeftColumn = function SearchLeftColumn(_ref) {
    var children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? null : _ref$className,
        loading = _ref.loading,
        title = _ref.title;

    var baseClass = 'booking';
    return _react2.default.createElement(
        _LeftColumn2.default,
        { className: (0, _classnames2.default)(baseClass, className), loading: loading },
        _react2.default.createElement(_SmartcardCTA2.default, null),
        title && _react2.default.createElement(
            'h1',
            { className: (0, _classnames2.default)(baseClass + '__title', 'sr-only') },
            title
        ),
        _react2.default.createElement(_SearchTabs2.default, null),
        children
    );
};

SearchLeftColumn.propTypes = {
    children: _propTypes2.default.any,
    className: _propTypes2.default.string,
    loading: _propTypes2.default.bool,
    title: _propTypes2.default.string
};

exports.default = SearchLeftColumn;

/***/ }),

/***/ 2700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = __webpack_require__(5);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _Link = __webpack_require__(275);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SearchTabs() {

    function _getTabs() {
        var classNames = 'pull-left text-center text-sm';

        var tabs = new _immutable.List();
        tabs = tabs.push(_react2.default.createElement(
            _Link2.default,
            { key: 'point',
                to: _AppConstants.PointStages.SEARCH,
                className: classNames,
                srOnly: (0, _I18n.translate)('global.searchFor') },
            (0, _I18n.translate)('nav.pointTickets')
        ));
        if (_FeatureFlagStore2.default.get('enableSeasonTickets')) {
            tabs = tabs.push(_react2.default.createElement(
                _Link2.default,
                { key: 'season',
                    to: _AppConstants.SeasonStages.SEARCH,
                    className: classNames,
                    srOnly: (0, _I18n.translate)('global.searchFor') },
                (0, _I18n.translate)('nav.seasonTickets')
            ));
        }
        if (_FeatureFlagStore2.default.get('enableOtherTickets')) {
            tabs = tabs.push(_react2.default.createElement(
                _Link2.default,
                { key: 'other',
                    to: _AppConstants.OtherTicketStages.SEARCH,
                    className: classNames,
                    srOnly: (0, _I18n.translate)('global.searchFor') },
                (0, _I18n.translate)('nav.otherTickets')
            ));
        }
        return tabs;
    }

    var tabs = _getTabs();

    var tabsClasses = (0, _classnames2.default)('search-tabs', {
        'search-tabs--thirds': tabs.size === 3
    });

    return _react2.default.createElement(
        'div',
        { className: tabsClasses },
        tabs.size > 1 ? _react2.default.createElement(
            'nav',
            { role: 'navigation', className: 'clearfix' },
            tabs
        ) : _react2.default.createElement(
            'h2',
            { className: 'text-center border--bottom' },
            (0, _I18n.translate)('nav.heading')
        )
    );
}

exports.default = SearchTabs;

/***/ }),

/***/ 2701:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _dec, _class, _class2, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _SmartcardCTAStore = __webpack_require__(1081);

var _SmartcardCTAStore2 = _interopRequireDefault(_SmartcardCTAStore);

var _ModalActions = __webpack_require__(27);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _SmartcardModal = __webpack_require__(1072);

var _SmartcardModal2 = _interopRequireDefault(_SmartcardModal);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _KeyGoRegistrationModal = __webpack_require__(2702);

var _KeyGoRegistrationModal2 = _interopRequireDefault(_KeyGoRegistrationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _handleDismiss = function _handleDismiss() {
    _CustomerActions2.default.dismissSmartcardCTA();
};

var _handleRegisterUser = function _handleRegisterUser() {
    _ModalActions2.default.open(_AppConstants.GlobalModals.REGISTER, { forceSmartcardSignup: true });
};

var SmartcardCTA = (_dec = (0, _connectToStores2.default)([_FeatureFlagStore2.default, _UserStore2.default, _SmartcardStore2.default, _SmartcardCTAStore2.default], function () {
    return {
        smartcard: _SmartcardStore2.default.getCurrent(),
        user: _UserStore2.default.getCurrent(),
        enableSmartcardCTA: _FeatureFlagStore2.default.get('enableSmartcardCTA'),
        enableKeyGoCTA: _FeatureFlagStore2.default.get('enableKeyGoCTA'),
        enableSmartcard: _FeatureFlagStore2.default.get('enableSmartcard'),
        dismissed: _SmartcardCTAStore2.default.get('dismissed'),
        showSmartcardModal: false
    };
}), _dec(_class = (_temp2 = _class2 = function (_PureRenderComponent) {
    (0, _inherits3.default)(SmartcardCTA, _PureRenderComponent);

    function SmartcardCTA() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SmartcardCTA);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            showModal: false
        }, _this._handleCancelled = function () {
            _this.setState({ showModal: false });
        }, _this._handleRegisterSmartcard = function () {
            _this.setState({ showModal: true });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    SmartcardCTA.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        if (!this.props.enableSmartcardCTA) {
            return;
        }

        if (_SmartcardStore2.default.shouldGetSmartcard()) {
            _CustomerActions2.default.getSmartcard(this.props.user);
        }
    };

    SmartcardCTA.prototype._canRegisterKeyGo = function _canRegisterKeyGo() {
        var _props = this.props,
            smartcard = _props.smartcard,
            enableKeyGoCTA = _props.enableKeyGoCTA;

        return smartcard && enableKeyGoCTA && smartcard.canSearchForProducts() && smartcard.canRegisterKeyGo();
    };

    SmartcardCTA.prototype.render = function render() {
        var _props2 = this.props,
            className = _props2.className,
            enableSmartcardCTA = _props2.enableSmartcardCTA,
            dismissed = _props2.dismissed,
            smartcard = _props2.smartcard,
            user = _props2.user,
            enableSmartcard = _props2.enableSmartcard;

        var canRegisterKeyGo = this._canRegisterKeyGo();

        if (!enableSmartcardCTA || dismissed || !enableSmartcard || smartcard && !canRegisterKeyGo) {
            return null;
        }

        var registrationHandler = (0, _result3.default)(user, 'isLoggedIn') ? this._handleRegisterSmartcard : _handleRegisterUser;
        var Modal = canRegisterKeyGo ? _KeyGoRegistrationModal2.default : _SmartcardModal2.default;

        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('smartcard-cta', className), role: 'dialog',
                'aria-modal': 'false',
                'aria-describedby': 'cta__description' },
            this.state.showModal && _react2.default.createElement(Modal, {
                user: user,
                smartcard: smartcard,
                hideSmartcardCheckbox: true,
                onCancel: this._handleCancelled }),
            _react2.default.createElement(
                'p',
                { id: 'cta__description' },
                canRegisterKeyGo ? this._keyGoMessage : (0, _I18n.translate)('smartcardCTA.message.smartcard')
            ),
            _react2.default.createElement(
                _Button2.default,
                { bsStyle: 'default',
                    className: 'text-sm btn btn-dismiss',
                    onClick: _handleDismiss },
                (0, _I18n.translate)('global.banner.dismiss')
            ),
            _react2.default.createElement(
                _Button2.default,
                { bsStyle: 'primary',
                    className: 'text-sm btn btn-register',
                    onClick: registrationHandler },
                (0, _I18n.translate)(canRegisterKeyGo ? 'smartcardCTA.button.submit.keyGo' : 'smartcardCTA.button.submit.smartcard')
            )
        );
    };

    (0, _createClass3.default)(SmartcardCTA, [{
        key: '_keyGoMessage',
        get: function get() {
            return _react2.default.createElement(_FormattedHTMLMessage2.default, {
                message: 'smartcardCTA.message.keyGo',
                br: _react2.default.createElement('br', null),
                keygobrand: _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' })
            });
        }
    }]);
    return SmartcardCTA;
}(_PureRenderComponent3.default), _class2.propTypes = {
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default),
    enableSmartcardCTA: _propTypes2.default.bool.isRequired,
    enableKeyGoCTA: _propTypes2.default.bool.isRequired,
    user: _propTypes2.default.instanceOf(_User2.default),
    dismissed: _propTypes2.default.bool.isRequired,
    className: _propTypes2.default.string
}, _class2.defaultProps = {
    className: ''
}, _temp2)) || _class);
exports.default = SmartcardCTA;

/***/ }),

/***/ 2702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _KeyGoStore = __webpack_require__(1004);

var _KeyGoStore2 = _interopRequireDefault(_KeyGoStore);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _AbstractKeyGoRegistration = __webpack_require__(2616);

var _AbstractKeyGoRegistration2 = _interopRequireDefault(_AbstractKeyGoRegistration);

var _KeyGoRegistration = __webpack_require__(2568);

var _KeyGoRegistration2 = _interopRequireDefault(_KeyGoRegistration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyGoRegistrationModal = (_dec = (0, _connectToStores2.default)([_KeyGoStore2.default], _AbstractKeyGoRegistration.getStateFromStores), _dec(_class = (_temp = _class2 = function (_AbstractKeyGoRegistr) {
    (0, _inherits3.default)(KeyGoRegistrationModal, _AbstractKeyGoRegistr);

    function KeyGoRegistrationModal() {
        (0, _classCallCheck3.default)(this, KeyGoRegistrationModal);
        return (0, _possibleConstructorReturn3.default)(this, _AbstractKeyGoRegistr.apply(this, arguments));
    }

    KeyGoRegistrationModal.prototype.render = function render() {
        var onCancel = this.props.onCancel;


        return _react2.default.createElement(
            _BaseModal2.default,
            {
                onClose: onCancel,
                hideClose: this.props.paymentSucceeded,
                onContinue: this.props.paymentSucceeded ? onCancel : this.handleKeyGoPay,
                continueText: this.props.paymentSucceeded ? 'button.text.close' : 'account.smartcard.keygo.signupButton',
                closeText: 'button.text.cancel',
                disableContinue: this.isButtonDisabled,
                titleText: 'smartcardCTA.message.signup.keyGo',
                className: 'modal--med' },
            _react2.default.createElement(_KeyGoRegistration2.default, this.keyGoRegistrationProps),
            this.renderRegistrationWarning()
        );
    };

    return KeyGoRegistrationModal;
}(_AbstractKeyGoRegistration2.default), _class2.propTypes = {
    onCancel: _propTypes2.default.func
}, _temp)) || _class);
exports.default = KeyGoRegistrationModal;

/***/ }),

/***/ 2704:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AppConstants = __webpack_require__(6);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _useLoadJPWidget2 = __webpack_require__(2705);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JPWidget = function JPWidget(_ref) {
    var params = _ref.params,
        userId = _ref.userId;

    var _useLoadJPWidget = (0, _useLoadJPWidget2.useLoadJPWidget)(),
        isWidgetBundleLoaded = _useLoadJPWidget.isWidgetBundleLoaded;

    var widgetRef = (0, _react.useRef)(false);

    var _useState = (0, _react.useState)(false),
        shouldJPWidgetBeRerendered = _useState[0],
        setShouldJPWidgetBeRerendered = _useState[1];

    (0, _react.useEffect)(function () {
        var initJPWidget = function initJPWidget() {
            try {
                if (!window.OtrlJPWidget) {
                    return;
                }
                var init = window.OtrlJPWidget.init;

                if (widgetRef.current && init) {
                    init((0, _extends3.default)({
                        id: widgetRef.current.id,
                        dataLayerName: _config2.default.get("gtmDataLayer"),
                        enableModalHeightResize: true
                    }, params));
                }
            } catch (error) {
                console.error("Error initializing JPWidget:", error);
            }
        };

        setShouldJPWidgetBeRerendered(true);
        setTimeout(function () {
            setShouldJPWidgetBeRerendered(false);
            initJPWidget();
        }, 0);

        /*eslint-disable */
    }, [userId, isWidgetBundleLoaded]);

    if (shouldJPWidgetBeRerendered) {
        return null;
    }

    return _react2.default.createElement(
        "div",
        {
            ref: widgetRef,
            className: "otrl-jpWidget-external-component",
            id: _AppConstants.JPWidgetConf.ID
        },
        _react2.default.createElement("span", { className: "otrl circle-spinner" })
    );
};

JPWidget.propTypes = {
    params: _propTypes2.default.object,
    userId: _propTypes2.default.number
};

exports.default = JPWidget;

/***/ }),

/***/ 2705:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.useLoadJPWidget = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = __webpack_require__(0);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _ExternalScript = __webpack_require__(1016);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useLoadJPWidget = exports.useLoadJPWidget = function useLoadJPWidget() {
    var _useState = (0, _react.useState)(false),
        isWidgetBundleLoaded = _useState[0],
        setIsWidgetBundleLoaded = _useState[1];

    var jpWidgetBundleUrl = _config2.default.get('jpWidgetBundleUrl');

    (0, _react.useEffect)(function () {
        var getJPWidgetScript = function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return (0, _ExternalScript.loadScript)(jpWidgetBundleUrl);

                            case 2:
                                setIsWidgetBundleLoaded(true);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            return function getJPWidgetScript() {
                return _ref.apply(this, arguments);
            };
        }();

        getJPWidgetScript();
    }, [jpWidgetBundleUrl]);

    return { isWidgetBundleLoaded: isWidgetBundleLoaded };
};

/***/ }),

/***/ 2954:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.roversRangersSchema = exports.daySaveSchema = exports.smartCarnetSchema = undefined;

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var smartCarnetSchema = exports.smartCarnetSchema = function smartCarnetSchema(SmartCarnetSearch) {
    if (!SmartCarnetSearch) {
        return null;
    }

    var stationFromName = (0, _get3.default)(SmartCarnetSearch, 'origin.name');
    var stationFromNLC = (0, _get3.default)(SmartCarnetSearch, 'origin.nlc');
    var stationFromCRS = (0, _get3.default)(SmartCarnetSearch, 'origin.crs');
    var stationDestinationName = (0, _get3.default)(SmartCarnetSearch, 'destination.name');
    var stationDestinationNLC = (0, _get3.default)(SmartCarnetSearch, 'destination.nlc');
    var stationDestinationCRS = (0, _get3.default)(SmartCarnetSearch, 'destination.crs');
    var rawFromDateTime = SmartCarnetSearch.startingDate && SmartCarnetSearch.startingDate.format('YYYY-MM-DD');

    var fromDateTime = SmartCarnetSearch.startingDate.isBefore((0, _TrainTime2.default)()) ? (0, _TrainTime2.default)().format('YYYY-MM-DD') : rawFromDateTime;

    if (!stationFromName || !stationFromNLC && !stationFromCRS || !stationDestinationName || !stationDestinationNLC && !stationDestinationCRS || !rawFromDateTime) {
        return null;
    }

    return {
        smartCarnet: {
            stationFrom: {
                name: stationFromName,
                nlc: stationFromNLC,
                crs: stationFromCRS
            },
            stationTo: {
                name: stationDestinationName,
                nlc: stationDestinationNLC,
                crs: stationDestinationCRS
            },
            fromDateTime: fromDateTime
        }
    };
};

var daySaveSchema = exports.daySaveSchema = function daySaveSchema(DaySaveSearch) {
    if (!DaySaveSearch) {
        return null;
    }

    var stationFromName = (0, _get3.default)(DaySaveSearch, 'origin.name');
    var stationFromNLC = (0, _get3.default)(DaySaveSearch, 'origin.nlc');
    var stationFromCRS = (0, _get3.default)(DaySaveSearch, 'origin.crs');
    var fromDateTime = DaySaveSearch.date && DaySaveSearch.date.format('YYYY-MM-DD');
    var adults = (0, _get3.default)(DaySaveSearch, 'adults');
    var children = (0, _get3.default)(DaySaveSearch, 'children');

    if (!stationFromName || !stationFromNLC && !stationFromCRS || !fromDateTime) {
        return null;
    }

    return {
        daySave: {
            stationFrom: {
                name: stationFromName,
                nlc: stationFromNLC,
                crs: stationFromCRS
            },
            fromDateTime: fromDateTime,
            adults: adults,
            children: children
        }
    };
};

var roversRangersSchema = exports.roversRangersSchema = function roversRangersSchema(RoversRangers) {
    if (!RoversRangers) {
        return null;
    }

    var roverType = (0, _get3.default)(RoversRangers, 'ticketType.code');
    var fromDateTime = RoversRangers.date && RoversRangers.date.format('YYYY-MM-DD');
    var adults = (0, _get3.default)(RoversRangers, 'adults');
    var children = (0, _get3.default)(RoversRangers, 'children');
    var railcards = RoversRangers.railcards && RoversRangers.railcards.size > 0 && RoversRangers.railcards.toJS().map(function (railcard, index) {
        return {
            id: index,
            quantity: railcard.quantity,
            railcardCode: railcard.code
        };
    });

    if (!roverType || !fromDateTime) {
        return null;
    }

    return {
        rovers: {
            roverType: roverType,
            fromDateTime: fromDateTime,
            adults: adults,
            children: children,
            railcards: railcards
        }
    };
};

/***/ }),

/***/ 3448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _InAppStore = __webpack_require__(160);

var _InAppStore2 = _interopRequireDefault(_InAppStore);

var _appVersion = __webpack_require__(351);

var _appVersion2 = _interopRequireDefault(_appVersion);

var _DeviceDetection = __webpack_require__(597);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SECRET_TIME_WINDOW_MS = 2000;

var secretStates = {
    IDLE: 'IDLE',
    LEFT_TRIGGERED: 'LEFT_TRIGGERED',
    RIGHT_TRIGGERED: 'RIGHT_TRIGGERED',
    SHOW: 'SHOW'
};

var SecretVersion = function (_React$PureComponent) {
    (0, _inherits3.default)(SecretVersion, _React$PureComponent);

    function SecretVersion() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SecretVersion);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            secretVersion: secretStates.IDLE,
            timeoutId: null
        }, _this._handleSecret = function (_ref) {
            var isLeftBox = _ref.isLeftBox;
            return function (e) {
                var _this$state = _this.state,
                    secretVersion = _this$state.secretVersion,
                    timeoutId = _this$state.timeoutId;

                e.preventDefault();

                var nextState = secretStates.IDLE;

                switch (secretVersion) {
                    case secretStates.IDLE:
                        if (isLeftBox) {
                            nextState = secretStates.LEFT_TRIGGERED;
                            _this.setState({
                                timeoutId: setTimeout(function () {
                                    return _this.setState({ secretVersion: secretStates.IDLE });
                                }, SECRET_TIME_WINDOW_MS)
                            });
                        }
                        break;

                    case secretStates.LEFT_TRIGGERED:
                        if (!isLeftBox) {
                            nextState = secretStates.RIGHT_TRIGGERED;
                        }
                        break;

                    case secretStates.RIGHT_TRIGGERED:
                        if (isLeftBox) {
                            nextState = secretStates.SHOW;
                            clearTimeout(timeoutId);
                        }
                        break;
                }

                _this.setState({ secretVersion: nextState });
            };
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    SecretVersion.prototype.componentWillUnmount = function componentWillUnmount() {
        clearTimeout(this.state.timeoutId);
    };

    SecretVersion.prototype.render = function render() {
        var secretVersion = this.state.secretVersion;


        if (!_InAppStore2.default.isInApp()) {
            return null;
        }

        return _react2.default.createElement(
            'div',
            { className: 'secret-version' },
            _react2.default.createElement(
                'div',
                { className: 'secret-version__box', onClick: this._handleSecret({ isLeftBox: true }) },
                secretVersion === secretStates.SHOW && _react2.default.createElement(
                    'dl',
                    { className: 'secret-version__box__list' },
                    _react2.default.createElement(
                        'dt',
                        null,
                        'App:'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _InAppStore2.default.getAppVersion()
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'BEng:'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _appVersion2.default && _appVersion2.default.version
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'Host:'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        window.location.protocol + '//' + window.location.host
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'Path:'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        window.location.pathname
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'Device:'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        (0, _DeviceDetection.deviceDetection)()
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'UA:'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        window.navigator.userAgent
                    ),
                    _react2.default.createElement(
                        'dt',
                        null,
                        'Extra:'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _config2.default.get('extraInfoSecretVersion')
                    )
                )
            ),
            _react2.default.createElement('div', { className: 'secret-version__box', onClick: this._handleSecret({ isLeftBox: false }) })
        );
    };

    return SecretVersion;
}(_react2.default.PureComponent);

exports.default = SecretVersion;

/***/ })

});


// WEBPACK FOOTER //
// js/pages/othertickets.6989d0a8b9a2e4e1c96d.js